import axios, { AxiosRequestConfig, AxiosResponse, ResponseType } from 'axios';

// Import the functions you need from the SDKs you need
// import { initializeApp } from 'firebase/app';
// import { getAnalytics } from 'firebase/analytics';
import JSZip from 'jszip';
import React from 'react';
import { getCookie, logout } from './appTools';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { browserCodeType, chunkImageUploadDataInterface, chunkImageUploadResultInterface, defaultApiReaponseInterface, dimensions_Interface, fileCodeType, imageFilesUploadResultInterface, isHiddenType, queryParameterInterface, regionInterface } from '../interface/Common.interface';
import { loginUserTypeType, RTN_interface } from '../interface/App.interface';
import { BROWSER_CODE, CHUNK_SIZE, FILE_CODE, REGION_LIST, TOAST_AUTO_CLOSE } from './const';
import * as exifr from 'exifr';
import dayjs, { Dayjs } from 'dayjs';
import { FileUsageCd_Type } from '../../CustomerPage/ProductManufacturing/static/interface/ProductItemPhoto.interface';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: 'AIzaSyCYzIwKqLjfujkfmdW8GlhrJ6t8QAiugAnk',
//   authDomain: 'oops-e8c72.firebaseapp.com',
//   projectId: 'oops-e8c72',
//   storageBucket: 'oops-e8c72.appspot.com',
//   messagingSenderId: '345734616574',
//   appId: '1:345734616574:web:abc36aaba1de42fa44dcaf',
//   measurementId: 'G-4LWWQ32735',
// };

// Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

class callAxiosClass {
    async api(
        {
            method,
            url,
            data,
            timeOut = 1000 * 60 * 10,
            responseType,
            token = getAccountData.token(),
            cache_control,
            signal,
            headers,
            origin_url = process.env.REACT_APP_API_URL,
        }: {
            method: "get" | "post" | "delete" | "put";
            url: string;
            data?: any;
            timeOut?: number;
            responseType?: ResponseType;
            token?: string;
            cache_control?: 'no-cache';
            signal?: AbortSignal;
            headers?: Record<string, string>;
            origin_url?: string;
        }
    ){

        let m_final_url = url;
        if(origin_url){
            m_final_url = `${origin_url}/${url}`;
        }

        const config: AxiosRequestConfig<any> = {
            method,
            url: m_final_url,
            maxBodyLength: Infinity,
            maxContentLength: Infinity
        };

        if (timeOut) {
            config.timeout = timeOut;
        }

        if (responseType) {
            config.responseType = responseType;
        }

        if (token) {
            config.headers = {
                Authorization: `Token ${token}`,
                ...(cache_control && { 'Cache-Control': cache_control }),
            };
        }

        if(headers){
            config.headers = {
                ...config.headers,
                ...headers,
            };
        }

        if (method === 'post' || method === 'delete' || method === 'put') {
            config.data = data;
        }

        if(signal){
            config.signal = signal;
        }

        return axios(config);
    }
}

const callAxios = new callAxiosClass();

const downloadFile = async (presignedUrl: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = presignedUrl;
    if (fileName) {
        link.download = fileName;
    }
    document.body.appendChild(link);
    link.click();
};

const isSuccess = (
  response: AxiosResponse<any, any> | { data: null; status: number; statusText: string; msg: string },
) => {
    if(response.status === 200){

        const response_data: defaultApiReaponseInterface<any> = response.data;

        if(response_data.status.code === 200 && response_data.status.msg === "OK"){
            return true;
        }else{
            return false;
        }

    }else{
        printStateMsg(response);
        return false;
    }
};

const printStateMsg = (response: AxiosResponse<any, any> | { data: null; status: number; statusText: string; msg: string }) => {
    dev_console.error(`status code : ${response.status}`);

    const response_data: defaultApiReaponseInterface<any> = response.data;
    dev_console.error(`msg: ${response_data.status.msg}`)
}

class divConsoleClass {
    log: (...args: any[]) => void;
    error: (...args: any[]) => void;
    trace: (...args: any[]) => void;

    constructor() {
        const result = whatIsMode();
        if (result.is_not_product_mode_safe) {
            this.log = console.log.bind(console);
            this.error = console.error.bind(console);
            this.trace = console.trace.bind(console);
        } else {
            this.log = () => {};
            this.error = () => {};
            this.trace = () => {};
        }
    }
}
export const dev_console = new divConsoleClass();

// 문자열이 숫자로만 이루어져 있는지 확인하는 함수
const isNumericString = (str: string) => {
    if (str) {
        const regex = /^[0-9]+$/;
        return regex.test(str);
    }
    return true;
}

// 전제 데이터 수와 한 페이지 당 표시할 데이터수를 입력받아 최소 필요 페이지 수를 구함
const getMaxPageNum = ({ count, item_per_page = 15 }: { count: number; item_per_page?: number }) => {
    if (item_per_page <= 0 || count <= 0) {
        return 1;
    }

    return Math.ceil(count / item_per_page);
};

// "2023-10-19T16:49:37.672341"형식의 문자열을 "2023-10-19"와 "16:49:37"로 분리시켜주는 함수
const transformISOString = (dateTimeString: string, format?: string): [string, string] | null => {
    // 주어진 문자열을 Date 객체로 파싱합니다.
    const dateTime = new Date(dateTimeString);

    // 파싱이 실패하면 null을 반환합니다.
    if (isNaN(dateTime.getTime())) {
        return null;
    }

    if (format === 'ko') {
        // 날짜를 "년 월 일" 형식으로 포맷합니다.
        const datePart = `${dateTime.getFullYear()}년 ${dateTime.getMonth() < 9 ? `0${dateTime.getMonth() + 1}` : dateTime.getMonth() + 1}월 ${dateTime.getDate() < 10 ? `0${dateTime.getDate()}` : dateTime.getDate()}일`;

        // 시간을 "시:분" 형식으로 포맷합니다.
        const hours = dateTime.getHours().toString().padStart(2, '0');
        const minutes = dateTime.getMinutes().toString().padStart(2, '0');
        const timePart = `${hours}:${minutes}`;

        return [datePart, timePart];
    } else {
        // 날짜와 시간을 추출합니다.
        const datePart = dateTime.toISOString().split('T')[0];
        const timePart = dateTime.toTimeString().split(' ')[0];

        return [datePart, timePart];
    }
}

// 11글자의 문자열이 전화번호형식인인지 검증
const isValidPhoneNumber = (phoneNumber: string): boolean => {
    // 1. 문자열의 길이가 11자리인지 확인
    if (phoneNumber.length !== 11) {
        return false;
    }

    // 2. 모든 문자열은 숫자로만 이루어져야 함
    if (!/^\d{11}$/.test(phoneNumber)) {
        return false;
    }

    const prefix = phoneNumber.slice(0, 3);
    const validPrefixes = ['010', '011', '016', '017', '019'];

    if (!validPrefixes.includes(prefix)) {
        return false;
    }

    return true;
}

// 전화번호에 하이픈을 추가하는 함수
/**
 * 한국 전화번호 형식(하이픈) 자동 변환 함수
 * 기준: 과학기술정보통신부 번호 관리 세칙 및 관행
 */
const addHyphens = (input: string): string => {
    if (!input) return "";

    // 숫자 이외의 문자 제거
    const cleaned = input.replace(/\D/g, '');
    const len = cleaned.length;

    // 1. 전국 대표번호 (1588, 1577 등) - 8자리
    if (len === 8) {
        return cleaned.replace(/(\d{4})(\d{4})/, '$1-$2');
    }

    // 2. 지역번호가 02(서울)인 경우
    if (cleaned.startsWith('02')) {
        if (len <= 2) return cleaned;
        if (len <= 5) return cleaned.replace(/(\d{2})(\d+)/, '$1-$2');
        if (len <= 9) return cleaned.replace(/(\d{2})(\d{3})(\d+)/, '$1-$2-$3');
        return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
    }

    // 3. 그 외 일반 번호 (010, 031, 050, 070 등)
    if (len <= 3) return cleaned;
    if (len <= 6) return cleaned.replace(/(\d{3})(\d+)/, '$1-$2');
    if (len <= 10) {
        // 10자리인 경우 3-3-4 구조
        return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }
    // 11자리 이상인 경우 3-4-4 구조 (12자리 이상 대비 끝자리를 모두 가져옴)
    return cleaned.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3');
};

// 비밀번호 조건건 충족 확인
const validatePassword = (password: string): string[] => {
    let errors: string[] = [];

    // 비밀번호 길이 확인
    if (password.length < 8 || password.length > 12) {
        errors.push('글자 수 8 ~ 12');
    }

    if(!/[A-Za-z]/.test(password)){
        errors.push('하나 이상의 영어 문자');
    }

    // 숫자 확인
    if (!/[0-9]/.test(password)) {
        errors.push('하나 이상의 숫자');
    }

    // 특수문자 확인
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password)) {
        errors.push('하나 이상의 특수 문자');
    }

    return errors;
}

// 이미지를 미리 순차적으로 캐시요청(정확히는 순차적으로 get요청을 보냄)
const preloadImages = async (urls: string[], limit = 3) => {
    const requests = urls.map((url) => () => axios.get(url));

    // 동시 요청 수를 제한하면서 요청을 순차적으로 실행
    for (let i = 0; i < requests.length; i += limit) {
        const batch = requests.slice(i, i + limit);
        await Promise.all(batch.map((req) => req()));
    }
};

// 클라이언트에서 이미지를 압축하여 zip으로 생성
const downloadOriginalImages = async ({
    image_list,
    isSetEncoded = true,
}: {
    image_list: string[];
    isSetEncoded?: boolean;
}) => {
    const zip = new JSZip();
    let downloadSuccessCount = 0; // 성공 카운트를 저장할 변수 초기화

    // 이미지 리스트 순회
    for (const [index, imgUrl] of image_list.entries()) {
        let encodedUrl = isSetEncoded ? encodeURI(imgUrl) : imgUrl;

        try {
            const response = await fetch(encodedUrl);
            if(response.ok){
                console.log("이미지 다운로드 성공");
                const imageBlob = await response.blob();

                let imageName = isSetEncoded ?
                    decodeURIComponent(encodedUrl.split('/').pop() || `image-${index}.JPG`) :
                    encodedUrl.split('/').pop() || `image-${index}.JPG`;

                zip.file(imageName, imageBlob, { binary: true });
                downloadSuccessCount++; // 성공 카운트 증가
            } else {
                console.log("이미지 다운로드 실패: 응답 상태가 ok가 아님");
                // 여기서는 실패한 경우 특별한 처리를 하지 않음
            }
        } catch (error) {
            console.error("이미지 다운로드 중 오류 발생:", error);
            // 오류 발생시 처리도 여기서
        }
    }

    // ZIP 파일 생성
    const zipBlob = await zip.generateAsync({ type: 'blob' });


    // ZIP 파일과 성공 카운트 반환
    return { zipFile: zipBlob, successCount: downloadSuccessCount };
};

// 보안성 향상을 위해 문자열에서 쿼리문과 직접적인 관련이 있는 특수문자를 제거해주는 함수
const sanitizeInput = (input: string): string => {
    const regex = /[';\\-]/g;
    return input.replace(regex, '');
}

// 가격에 콤마(,)를 추가하는 함수
const addCommasToPrice = (price: string | number): string => {
    try{
        const priceStr = price.toString();
        const formattedPrice = priceStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return formattedPrice;
    }catch(error){
        dev_console.error(error);
        return "";
    }

}

// 세션에 저장된 토큰값과 user_type을 확인하여 결과에 따라 logout함수를 실행시킴(로드아웃 시킴);
const isAbleAccesser = (
    {
        allowedUserTypeList,
    }:{
        allowedUserTypeList?: loginUserTypeType[];
    }
) => {

    const all_user_type_list:loginUserTypeType[] = ["C", "E"];

    const token = getAccountData.token();
    const user_type = getAccountData.user_type();

    if(allowedUserTypeList){
        const result = allowedUserTypeList.find((item) => item === user_type);

        if(!token || !result){
            logout();
        }
    }else{
        const result = all_user_type_list.find((item) => item === user_type);

        if(!token || !result){
            logout();
        }
    }
}

// SQL 인젝션과 XSS 공격을 방지하기 위해 입력된 문자열을 검증하는 함수
const validateInput = (input: string, isKo: boolean = false): boolean => {
    // SQL 인젝션과 XSS 공격을 시도할 수 있는 위험한 문자열 패턴 정의
    const dangerousPatterns = [
        /['";]/, // SQL 인젝션에 사용될 수 있는 문자
        /<script.*?>/, /<\/script>/, // XSS 공격에 사용될 수 있는 스크립트 태그
        /<img.*?>/, // 이미지 태그를 이용한 XSS 공격
        /javascript:/, // "javascript:" 프로토콜을 이용한 공격
        /<iframe.*?>/, /<\/iframe>/, // iframe을 이용한 공격
        /onerror=/, /onload=/, // 이벤트 핸들러를 이용한 XSS 공격
        /\s/ // 공백 문자 (스페이스, 탭, 줄바꿈, 캐리지 리턴 포함)
    ];

    if(!isKo){
        // 한글 문자 범위를 정의하는 정규 표현식 추가
        const koreanPattern = /[가-힣]/;
        if (koreanPattern.test(input)) {
            dev_console.log(`catch ${koreanPattern}`);
            return false; // 위험한 패턴 중 하나라도 발견되면 false 반환
        }
    }

    // 위험한 패턴들을 순회하며 입력값 검사
    for (const pattern of dangerousPatterns) {
        if (pattern.test(input)) {
            dev_console.log(`catch ${pattern}`);
            return false; // 위험한 패턴 중 하나라도 발견되면 false 반환
        }
    }

    return true; // 모든 검사를 통과하면 true 반환
}

// 선택된 div 에서 오버플로우가 발생했는지 확인하는 함수
const checkOverflow = (div_ref: React.RefObject<HTMLDivElement>) => {
    const element = div_ref.current;

    let hasVerticalOverflow = false;
    let hasHorizontalOverflow = false;

    if(element){
        hasVerticalOverflow = element.scrollHeight > element.clientHeight;
        hasHorizontalOverflow = element.scrollWidth > element.clientWidth;
    }

    return ({
        y: hasVerticalOverflow,
        x: hasHorizontalOverflow,
    })
};

// 입력받은 문자열의 불필요하거나 과도한 공백문자를 제거하는 함수
const refineString = (str: string): string => {
    // 문자열의 모든 줄바꿈과 탭을 공백으로 변환
    let refinedStr: string = str.replace(/[\n\r\t]+/g, ' ');

    // 문자열 내의 2개 이상의 공백을 단일 공백으로 줄임
    refinedStr = refinedStr.replace(/\s\s+/g, ' ');

    // 문자열의 앞뒤 공백 제거
    return refinedStr.trim();
}

// 어떤 div안에 들어갈 마지막 항목이 가질수 있는 최대 높이를 계산하는 함수
const calculateLastDivHeight = (
    {
        wrapperDiv,
        innerDivs,
        spacing,
    }:{
        wrapperDiv: HTMLElement;    //  전체를 감싸는 몸체
        innerDivs: HTMLElement[];   //  마지막 자식항목을 제외한 항목들
        spacing: string;    //  간격
    }
): string => {
    // 간격 단위 추출 (px 또는 rem)
    const spacingUnit = spacing.includes('px') ? 'px' : 'rem';

    // 숫자로 된 간격 값 추출
    const spacingValue = parseFloat(spacing);

    // 간격 총합 계산
    const totalSpacing = (innerDivs.length - 1) * spacingValue;

    // 내부 div들의 높이 총합 계산
    const totalInnerDivsHeight = innerDivs.reduce((acc, div) => acc + div.offsetHeight, 0);

    // 전체 wrapperDiv의 높이 추출
    const wrapperDivHeight = wrapperDiv.offsetHeight;

    // rem 단위인 경우, document의 font-size를 기준으로 px 단위로 변환
    let convertedSpacing = totalSpacing;
    if (spacingUnit === 'rem') {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    convertedSpacing = totalSpacing * rootFontSize;
    }

    // 마지막 div의 최대 높이 계산
    const lastDivMaxHeight = wrapperDivHeight - totalInnerDivsHeight - convertedSpacing;

    // 계산된 높이를 원래 단위로 변환하여 리턴
    return spacingUnit === 'px' ? `${lastDivMaxHeight}px` : `${lastDivMaxHeight / parseFloat(getComputedStyle(document.documentElement).fontSize)}rem`;
};

// 시간형식의 문자열 두개를 입력받아서 몇 분의 차이가 나는지 리턴
const getTimeDifferenceInMinutes = (time1: string, time2: string, flag?: boolean): number => {
    // 시간을 분으로 변환하는 헬퍼 함수
    const convertToMinutes = (time: string): number | null => {
        const parts = time.split(':');
        if (parts.length !== 2) return null;

        const [hoursStr, minutesStr] = parts;
        const hours = parseInt(hoursStr, 10);
        const minutes = parseInt(minutesStr, 10);

        // 시간과 분이 숫자로 변환 가능한지 체크
        if (isNaN(hours) || isNaN(minutes)) return null;
        // 시간과 분이 유효한 범위인지 체크
        if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null;

        return hours * 60 + minutes;
    };

    const minutes1 = convertToMinutes(time1);
    const minutes2 = convertToMinutes(time2);

    // 둘 중 하나라도 유효하지 않으면 -1 반환
    if (minutes1 === null || minutes2 === null) return -1;

    let result = Math.abs(minutes2 - minutes1);
    if(flag){
        result += 1;
    }

    return result;
}

// 문자열이 이메일 형식의 조건을 충족하는지 검사하는 함수
const validateEmail = (email: string): boolean => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
};

// 성별을 코드화 하는 함수
const getGenderCode = (gender: string) => {
    if(gender.includes("남")){
        return 1;
    }else if(gender.includes("여")){
        return 2;
    }else{
        return 0;
    }
}

// 함수 인자 사이사이에 구분자? 원소를 삽입해주는 함수
// ex) [1,2,3,4,5], 0 => [1,0,2,0,3,0,4,0,5]
const insertBetweenList = <T>(arr: T[], value: T): T[] => {
    return arr.reduce((acc, curr, index) => {
        acc.push(curr);
        if(index < arr.length - 1){
            acc.push(value);
        }
        return acc;
    }, [] as T[]);
}

// 어떤 수가 두 수 사이에 포함되는지 검증하는 함수
const isBetweenNum = ({min, max, value, inclusive}:{min: number; max: number; value: number; inclusive: boolean}):boolean => {
    //  inclusive === true : min과 max값도 범위에 포함된다.(이하, 이상)
    //  inclusive === true : min과 max값도 범위에 포함되지 않는다.(미만, 초과)

    // 작은수보다 큰 수가 작은경우는 무조건 false
    if(min > max){
        return false;
    }

    if(inclusive){
        return value >= min && value <= max;
    }else{
        return value > min && value < max;
    }
}

// 파일의 S3주소에서 파일의 타입을 추출하는 함수.
const getFileType = (filePath: string): fileCodeType => {

    const cleanFilePath = filePath.split('?')[0];

    // 파일 확장자 목록
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'webp', 'svg'];
    const videoExtensions = ['mp4', 'avi', 'mkv', 'mov', 'flv', 'wmv', 'webm', 'm4v'];
    const archiveExtensions = ['zip', 'rar', '7z', 'tar', 'gz'];

    // 파일 확장자 추출
    const extension = cleanFilePath.split('.').pop()?.toLowerCase();

    // 파일 유형 판별
    if (extension) {
        if (imageExtensions.includes(extension)) {
            return FILE_CODE.img; // 이미지 파일
        } else if (videoExtensions.includes(extension)) {
            return FILE_CODE.video; // 동영상 파일
        } else if (archiveExtensions.includes(extension)) {
            return FILE_CODE.zip; // 압축 파일
        } else {
            return FILE_CODE.none; // 기타 파일
        }
    } else {
        return FILE_CODE.none; // 확장자가 없는 경우
    }
}

// 파일의 S3주소에서 파일의 타입을 추출하는 함수.
const getFileName = (filePath: string): string => {
    // 파일 확장자 추출
    return filePath.split('/').pop() || "";
}

// 파일의 해시값을 계산
const getFileHash = async (file: File): Promise<string> => {
    const arrayBuffer = await file.arrayBuffer();
    const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}

// 파일 배열값들 중 중복된 파일을 감지 및 중복이 제거된 파일 과 중복이 감지된 파일 리턴
const detectDuplicates = async (files: File[]): Promise<{ duplicateFiles: File[]; duplicateFileNames:string[]; uniqueFiles: File[] }> => {
    const duplicateFiles: File[] = [];
    const duplicateFileNames: string[] = [];
    const uniqueFiles: File[] = [];
    const seenHashes = new Set<string>();
    const seenNames = new Set<string>();

    for (const file of files) {
        const hash = await getFileHash(file);
        const name = file.name;

        if (seenNames.has(name)){
            duplicateFileNames.push(name)
            customToast.error({msg:`${name} 파일 명이 중복됩니다.`});
            dev_console.error(name);
        }else if (seenHashes.has(hash)) {
            // 중복된 파일 발견
            duplicateFiles.push(file);
            customToast.error({msg: `${file.name} 파일이 중복됩니다.`});
            dev_console.error(file.name);
        } else {
            uniqueFiles.push(file);
            seenHashes.add(hash);
            seenNames.add(name);
        }
    }

    dev_console.error(seenHashes)

    return {
        duplicateFiles,
        duplicateFileNames,
        uniqueFiles
    };
}

// 쿼리파라미터 사용을 위한 문자열을 생성해주는 함수
const setQueryParameter = (parameter: queryParameterInterface[]) => {
    return parameter.map((item) => `${item.key}=${item.value}`).join("&");
}

// 배열 내용 비교 함수
const arraysAreEqual = <T>(arr1: T[], arr2: T[]): boolean => {
    if (arr1.length !== arr2.length) {
        return false;
    }
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }
    return true;
};

// 테스트모드상태(테스트 데이터 사용) 확인
export const isUseTestData = () => {
    return process.env.REACT_APP_IS_TEST_MODE === "TRUE";
}

// 개발모드상태 확인
export function whatIsMode(){
    const mode = process.env.REACT_APP_MODE;

    const is_normal_mode: boolean = (mode === "LOCAL" || mode === "DEV" || mode === "STAGE" || mode === "PRODUCT")

    return {
        // 현재 상태가 해당 상태인가
        is_product_mode: mode === "PRODUCT",
        is_stage_mode: mode === "STAGE",
        is_dev_mode: mode === "DEV",
        is_loacl_mode: mode === "LOCAL",

        // 현재 상태가 해당 상태가 아닌가
        is_not_product_mode: mode !== "PRODUCT",
        is_not_stage_mode: mode !== "STAGE",
        is_not_dev_mode: mode !== "DEV",
        is_not_loacl_mode: mode !== "LOCAL",

        // 정상적인 상태인가
        is_normal_mode: is_normal_mode,

        // 현재 상태가 해당 상태는 아니지만, 정상정인 상태값을 가지는가
        is_not_loacl_mode_safe: mode !== "LOCAL" && is_normal_mode,
        is_not_product_mode_safe: mode !== "PRODUCT" && is_normal_mode,
        is_not_stage_mode_safe: mode !== "STAGE" && is_normal_mode,
        is_not_dev_mode_safe: mode !== "DEV" && is_normal_mode,

        // 현재 모드 이름
        mode_name: process.env.REACT_APP_MODE,

        // 현재 연결된 엔드포인트 주소
        get_api_url: process.env.REACT_APP_API_URL,
    };
}

const chunkUpload = async (
    {
        index,
        CHUNK_SIZE,
        file_size,
        file,
        file_name,
        total_chunks,
        file_idx,
        file_extension,
        file_dir,
    }:{
        index: number;
        CHUNK_SIZE: number;
        file_size: number;
        file: File;
        file_name: string;
        total_chunks: number;
        file_idx: number;
        file_extension: string;
        file_dir: string;
    }
) => {
    const start = index * CHUNK_SIZE;
    const end  = Math.min(start + CHUNK_SIZE, file_size);
    const chunk = file.slice(start, end);

    const form_data = new FormData();
    form_data.append("file_name", file_name);
    form_data.append("total_chunks", `${total_chunks}`);
    form_data.append("files", chunk);
    form_data.append("file_dir", file_dir);
    form_data.append("current_chunk", `${index}`);
    form_data.append("file_idx", `${file_idx}`);
    form_data.append("file_ext", file_extension);

    const common_img_upload_url = "api/v1/pgp/common-img-upload";
    return await callAxios.api({
        url: common_img_upload_url,
        method: "post",
        data: form_data,
        // cache_control: "no-cache", // 해당 헤더를 설정하기 위해선 장고서버의 허용이 필요하다.
    })
}

export class getAccountDataClass{

    //
    // 쿠키에 이런 데이타를 담아 놓는 것은 보안에 큰 영향을 미칠 수 있으니 쿠키가 아닌 방식으로 개선이 필요함.
    // 현재는 기존코드를 최대한 수정하지 않고 최소시간으로 작업해야 하는 상황이라 수정하지 않지만 다음 작업자가 확인하면 개선 하기 바람. (Bruce.Cheong 2026-04-30)
    //

    token(){
        return getCookie("token") || "";
    }

    oops_id(): string{
        return getCookie("oops_id") || "";
    }

    name(): string{
        return getCookie("name") || "";
    }

    user_type(){
        let RTN: string = "";

        const m_userType = getCookie("user_type") || "";

        RTN = m_userType;

        return RTN;
    }

    user_id(): number{
        return parseInt(getCookie("user_id") || "0");
    }

    office_id(): number{
        return parseInt(getCookie("office_id") || "0");
    }

    office_name(): string{
        return getCookie("office_name") || "";
    }

    office_addr(): string{
        return getCookie("office_addr") || "";
    }

    office_addr_detail(): string{
        return getCookie("office_addr_detail") || "";
    }

    brand_id(): number{
        return parseInt(getCookie("brand_id") || "0");
    }

    brand_name(): string{
        return getCookie("brand_name") || "";
    }
}

export const getAccountData = new getAccountDataClass();

const imageChunkUpload = async (
    {
        file,
        file_idx,
        file_dir,
    }:{
        file: File;
        file_idx: number;
        file_dir: string;
    }
) => {
    const file_name = file.name;
    const file_size = file.size;
    const file_extension = file_name.substring(file_name.lastIndexOf(".") + 1);
    const total_chunks = Math.ceil(file.size / CHUNK_SIZE);

    const result: chunkImageUploadResultInterface = {
        state: 0,
        message: "",
        next_fleg: false,
        is_error: false,
        data: {
            file_name,
            file_size,
            file_extension,
        }
    }

    // dev_console.log(`${total_chunks} = ${file.size} / ${CHUNK_SIZE}`)

    let index: number = 0;
    while(index < total_chunks){
        try{
            const response = await chunkUpload({
                index,
                CHUNK_SIZE,
                file_size,
                file,
                file_name,
                total_chunks,
                file_idx,
                file_extension,
                file_dir
            });

            if(response.status === 200){
                const code = response.data.status.code;

                if (code === 200) {
                    result.state = code;
                    result.message = "success";
                    result.next_fleg = true;
                    result.is_error = false;
                    break;
                } else if (code === 201) {
                    // 다음 청크 업로드 준비됨
                    index += 1;
                } else {
                    // 에러 처리
                    result.state = -1;
                    result.message = "state_error";
                    dev_console.error(`응답된 상태값이 ${code}입니다.`);
                    result.next_fleg = false;
                    result.is_error = true;
                    break;
                }
            }else{
                result.state = -1;
                result.message = "state_error";
                dev_console.error(`서버 state에러: ${response.status}입니다.`);
                result.next_fleg = false;
                result.is_error = true;
            }
        }catch(error){
            result.state = -1;
            result.message = "requset_error";
            dev_console.error("요청중 문제가 발생했습니다.");
            dev_console.error(error);
            result.next_fleg = false;
            result.is_error = true;
            break;
        }
    }

    return result;
}

const imageFilesUpload = async (
    {
        files,
        file_dir
    }:{
        files: File[],
        file_dir: string;
    }
) => {

    const total_result: imageFilesUploadResultInterface = {
        state: 0,
        message: "",
        data: [],
    }

    let index: number = 0;
    const data_list:chunkImageUploadDataInterface[] = [];

    const toast_id = file_dir;

    while(index < files.length){
        dev_console.log(`${index + 1} - ${files.length}`);

        try{
            const result = await imageChunkUpload({
                file: files[index],
                file_idx: index,
                file_dir
            })

            total_result.state = result.state;
            total_result.message = result.message;
            if(result.next_fleg){
                if(result.data){
                    data_list.push(result.data);
                }

                customToast.info({
                    msg: `${index + 1} / ${files.length}`,
                    autoClose: false,
                    toastId: toast_id,
                })

                index++;
            }else{
                if(result.is_error){
                    break ;
                }
            }
        }catch(error){
            total_result.state = -1;
            total_result.message = "error";
            dev_console.error("파일 업로드 중 오류가 발생했습니다.");
            dev_console.error(error);
            break ;
        }
    }

    toast.dismiss(toast_id);

    total_result.data = data_list;

    dev_console.log(total_result);

    return total_result;
}


interface presignedRequest_Interface{
    file_num: number;
    file_name: string;
    file_url: string;
}

interface presignedResponse_Interface{
    file_num: number;
    file_url: string;
}

export class imageUploadManagerClass{

    // File객체의 type으로 부터 확장자를 추출하는데 사용되는 메소드
    mimeToExtMap: Record<string, string> = {
        "image/jpeg": "jpg",
        "image/png": "png",
        "image/gif": "gif",
        "application/pdf": "pdf",
        "text/plain": "txt",
        "application/zip": "zip",
        "video/mp4": "mp4"
    };

    // S3로 직접 이미지를 업로드하기 위한 주소를 요청하는데 사용되는 데이터 프리셋을 생성하는 메소드
    #getPresignedRequestFileList(
        {
            files,
            file_dir
        }:{
            files: File[],
            file_dir: string;
        }
    ){
        const RTN: presignedRequest_Interface[] = [];

        for(let index = 0; index < files.length; index++){
            const file = files[index];
            const file_name = file.name;

            RTN.push({
                file_num: index + 1,
                file_name,
                file_url: file_dir
            });
        }

        return RTN;
    }

    // S3로 직접 이미지를 업로드하기 위한 주소를 요청하는 메소드
    async #getImageUploadS3Url(
        {
            files,
            file_dir
        }:{
            files: File[],
            file_dir: string;
        }
    ){
        const RTN: RTN_interface<presignedResponse_Interface[]> = {
            sign: false,
            data: [],
            msg: "",
        }

        const m_file_list = this.#getPresignedRequestFileList({files, file_dir});

        const m_config = {
            file_list: m_file_list,
        }

        try{
            const m_file_upload_presigned_url = "api/v3/file/upload/presigned/url";

            const response = await callAxios.api({
                url: m_file_upload_presigned_url,
                method: "post",
                data: m_config,
            })

            if(isSuccess(response)){
                const data: defaultApiReaponseInterface<presignedResponse_Interface[]> = response.data;

                RTN.sign = true;
                RTN.data = data.result;
                RTN.msg = "success";
            }
        }catch(error){
            dev_console.error(error);

            RTN.sign = false;
            RTN.msg = `이미지 업로드용 S3 presigned url 요청 중 오류가 발생했습니다.`;
            RTN.data = [];
        }

        if(!RTN.sign){
            dev_console.error(RTN.msg);
        }

        return RTN;
    }

    // S3에 직접 1개의 이미지를 업로드하는 메소드
    async #directImageUpload(
        {
            file,
            request_url,
        }:{
            file: File,
            request_url: string;
        }
    ){
        const RTN: RTN_interface<AxiosResponse<any, any> | null> = {
            sign: false,
            data: null,
            msg: "",
        }

        try{
            dev_console.log(
                "요청 데이터", {
                    method: "put",
                    url: request_url,
                    dataType: "file",
                    data: file,
                    self_token: "",
                    headers: {
                        "Content-Type": file.type
                    },
                    origin_url: "",
                }
            );

            const response = await callAxios.api({
                method: "put",
                url: request_url,
                data: file,
                token: "",
                headers: {
                    "Content-Type": file.type
                },
                origin_url: "",
            })

            RTN.data = response;
            RTN.sign = true;
            RTN.msg = "success";
        }catch(error){
            dev_console.error(error);

            RTN.msg = `${file.name}파일을 ${request_url}에 업로드 중 오류가 발생했습니다.`;
            RTN.sign = false;
            RTN.data = null;
        }

        if(!RTN.sign){
            dev_console.error(RTN.msg);
        }

        return RTN;
    }

    async uploadImage(
        {
            files,
            file_dir
        }:{
            files: File[],
            file_dir: string;
        }
    ){
        const RTN: RTN_interface<presignedResponse_Interface[]> = {
            sign: false,
            data: [],
            msg: "",
        }

        Process_Start:{
            const m_getImageUploadS3Url_result = await this.#getImageUploadS3Url({
                files,
                file_dir
            });

            if(!m_getImageUploadS3Url_result.sign){
                RTN.sign = false;
                RTN.msg = m_getImageUploadS3Url_result.msg;
                break Process_Start;
            }

            RTN.sign = true;

            for(const presigned_data of m_getImageUploadS3Url_result.data){
                const m_file_num = presigned_data.file_num - 1;

                const m_directImageUpload_result = await this.#directImageUpload({
                    file: files[m_file_num],
                    request_url: presigned_data.file_url
                });

                if(!m_directImageUpload_result.sign){
                    RTN.sign = false;
                    RTN.data.push(presigned_data);
                    RTN.msg = "이미지 업로드중 오류가 발생했습니다.";
                }
            }
        }

        if(!RTN.sign){
            dev_console.error(RTN.msg);
            dev_console.error(`${RTN.data.length}개의 이미지 업로드에 실패했습니다.`, RTN.data);
        }

        return RTN;
    }
}

export class imageUploadManagerClass2{
    // 가비지 업로드 이미지가 있는 지 확인 (동시성 문제 해결)
    async FileUploadR2GarbageCheck(
        iWHERE: {
            log_in_staff_id?: number;
            brand_id?: number;
            file_usage_cd?: number;
            data_pk?: number;
        } = {},
        iArgs: {
            showConfirm?: boolean;
            garbageClearIfGarbageExists?: boolean;
        }={
            showConfirm                 : true ,
            garbageClearIfGarbageExists : true ,
        }
    ) {

        let RTN = {
            isContinue : false ,
            message : "" ,
        };

        const _V: {
            logInStaffId?: number;
            qsRequired: {
                brand_id: number;
                file_usage_cd: number;
                data_pk: number;
                upload_status_cd: number;
            };
            showConfirm: boolean;
            garbageClearIfGarbageExists: boolean;
            postData: {
                brand_id?: number;
                file_usage_cd?: number;
                data_pk?: number;
                is_all_clear?: number;
                upload_file_pk?: number;
            };
            isGarbageClear: boolean;
            showMessage: string;
            fetchResponse: AxiosResponse<any, any> | null;
            fetchData: any | null;
            tmp: number | null;
            garbageConditionMin: number;
            garbageStatusCd: number;
            garbageUploadedDiffMin: number | boolean | string;
        } = {
            logInStaffId     :   iWHERE.log_in_staff_id ,

            qsRequired       :   {
                brand_id        :   iWHERE?.brand_id || 0 ,
                file_usage_cd   :   iWHERE?.file_usage_cd || 0 ,
                data_pk         :   iWHERE?.data_pk || 0 ,
                upload_status_cd:   1 ,   // 1 - 업로드 중
            } ,
            showConfirm                 :   (iArgs?.showConfirm !== false) ? true : false ,
            garbageClearIfGarbageExists :   (iArgs?.garbageClearIfGarbageExists !== false) ? true : false ,
            postData         :   {} ,

            isGarbageClear  :   false ,
            showMessage     :   "" ,

            fetchResponse   :   null ,
            fetchData       :   null ,

            garbageConditionMin     :   10 ,    // 업로드 중인 파일 중 가비지 파일로 간주하는 업로드 중단 시간 (분)
            garbageStatusCd         :   0 ,     // 가비지 파일 존재 상태 코드 (0: 없음, 1: 내가 업로드 중인 상태 존재(진행 중 예상), 2: 내가 업로드 중인 상태 존재(오류 예상), 3: 다른 사용자가 업로드 중인 상태 존재(진행 중 예상), 4: 다른 사용자가 업로드 중인 상태 존재(오류 예상) )
            garbageUploadedDiffMin  :   -1 ,    // 업로드된지 몇분이 지났는지

            tmp             :   null ,
        };





        if ( this.#isEmpty(_V.logInStaffId) ) {
            throw new Error("사용자 정보가 없습니다.");
        }
        if ( this.#isEmpty(_V.qsRequired.brand_id) ) {
            throw new Error("브랜드 정보가 없습니다.");
        }
        if ( this.#isEmpty(_V.qsRequired.file_usage_cd) ) {
            throw new Error("파일 사용 용도 정보가 없습니다.");
        }
        if ( this.#isEmpty(_V.qsRequired.data_pk) ) {
            throw new Error("데이타 정보가 없습니다.");
        }





        Close_RTN: {
            // // 가지비 업로드 파일 fetch
            // _V.fetchResponse = await gf_LOCAL_API_FETCH_ASYNC(
            //     _V.csrfToken,
            //     "common_api:api_file_list",
            //     {
            //         qs_required :  _V.qsRequired ,
            //     }
            // );
            // gf_LOCAL_API_FETCH_RESULT_PROCESS(_V.fetchResponse, false);

            const fileListOriginUrl = "api/v3/common/file-list";

            // 1. URLSearchParams 객체 생성
            const params = new URLSearchParams();

            // 2. 단일 파라미터 추가 (append 사용)
            params.append("brand_id", _V.qsRequired.brand_id.toString());
            params.append("data_pk", _V.qsRequired.data_pk.toString());
            params.append("upload_status_cd", _V.qsRequired.upload_status_cd.toString());
            params.append("file_usage_cd", _V.qsRequired.file_usage_cd.toString());
            params.append("get_field[]", "upload_file_detail_data");

            // 4. 최종 URL 생성
            // params.toString()이 자동으로 'key=val&key=val' 형태로 변환하며 인코딩까지 처리합니다.
            const fileListUrl = `${fileListOriginUrl}?${params.toString()}`;

            _V.fetchResponse = await callAxios.api({
                method: "get",
                url: fileListUrl,
            });

            if (_V.fetchResponse.status != 200) {
                throw new Error(`파일 목록 요청 실패: ${_V.fetchResponse.status}`);
            }

            if(_V.fetchResponse.data.status.code != 200){
                throw new Error(`파일 목록 요청 실패 Error: ${_V.fetchResponse.data.status.message}`);
            }

            // 업로드 중인 파일이 없는 경우 바로 true 반환 (가비지 파일이 없음)
            if ( this.#isEmpty(_V.fetchResponse?.data?.result?.data?.length) ) {
                RTN.isContinue = true;
                break Close_RTN;
            }





            // 업로드 중인 파일 PK 저장
            _V.postData.upload_file_pk = _V.fetchResponse.data?.result?.data?.[0]?.upload_file_pk || null;





            // 가지비 파일이 내가 올린 파일인 지 확인
            _V.fetchData = _V.fetchResponse.data?.result?.data?.[0] || null;

            // 업로드한지 몇분이 지났는지
            if ( this.#DateFormat(_V.fetchData.upload_file_ts) !== false ) {
                _V.garbageUploadedDiffMin = this.#DateDiff(_V.fetchData.upload_file_ts, null, false, "minute")
            }

            // 가비지 파일 존재 상태 코드
            _V.garbageStatusCd = (_V.fetchData.staff_id == _V.logInStaffId) ? 1 : 2;

            // 업로드된지 제한시간 이상 지났는지 여부
            _V.garbageStatusCd += (_V.garbageUploadedDiffMin as number >= _V.garbageConditionMin) ? 1 : 0;



            switch (_V.garbageStatusCd)  {
                case 1: // 내가 올린 파일이 있는 경우 (진행 중 예상)
                    _V.showMessage = "업로드 중인 파일이 있습니다.\n다른 PC(또는 브라우저)에서 업로드 중 이거나, 이전 업로드 중 오류가 발생했을 수 있습니다.";
                    break;
                case 2: // 내가 올린 파일이 있는 경우 (오류 예상)
                    _V.showMessage = "업로드 중인 파일이 있습니다.\n이전에 업로드가 중단이나 오류가 발생한 것으로 보입니다.";
                    break;
                case 3: // 다른 사용자가 올린 파일이 있는 경우 (진행 중 예상)
                    _V.showMessage = `"${_V.fetchData.staff_name}"님이 업로드 중인 파일이 있습니다.\n현재 업로드가 진행 중 일 수 있습니다. 확인 후 다시 시도해 주세요.\n\n"* ${_V.fetchData.staff_name}"님이 업로드를 진행하거나 ${_V.garbageUploadedDiffMin}분 후 다시 시도해 주세요.`;
                    break;
                case 4: // 다른 사용자가 올린 파일이 있는 경우 (오류 예상)
                    _V.showMessage = `"${_V.fetchData.staff_name}"님이 업로드 중인 파일이 있습니다.\n이전에 업로드가 중단이나 오류가 발생한 것으로 보입니다.`;
                    break;
            }



            if ( _V.showConfirm ) {
                _V.isGarbageClear = window.confirm(`${_V.showMessage}\n\n업로드를 진행하시겠습니까?\n(이전 업로드 중인 파일은 정리 됩니다.)`);
            }



            // 가비지 초기화 가능상태가 아니면 빠져나감
            if ( !_V.isGarbageClear ) {
                RTN.message = _V.showMessage;
                break Close_RTN;
            }


            // 가비지 파일 삭제 처리
            if ( _V.garbageClearIfGarbageExists ) {

                _V.postData.brand_id         =  _V.qsRequired.brand_id;
                _V.postData.file_usage_cd    =  _V.qsRequired.file_usage_cd;
                _V.postData.data_pk          =  _V.qsRequired.data_pk;
                _V.postData.is_all_clear     =  1 ; // 1 - 모두 삭제

                /** upload_file_pk 는 위에서 설정됨 */

                // 가비지 파일 삭제
                // _V.fetchResponse = await gf_LOCAL_API_FETCH_ASYNC(
                //     _V.csrfToken,
                //     "common_post_api:api_file_data_delete",
                //     {
                //         post_data :  _V.postData
                //     }
                // );
                // gf_LOCAL_API_FETCH_RESULT_PROCESS(_V.fetchResponse, false);

                _V.fetchResponse = await callAxios.api({
                    url: "api/v3/common/file-data-delete",
                    method: "post",
                    data: _V.postData,
                })

                if (_V.fetchResponse.status != 200) {
                    throw new Error(`가비지 파일 삭제 실패: ${_V.postData.file_usage_cd}`);
                }

                if(_V.fetchResponse.data.status.code != 200){
                    throw new Error(`가비지 파일 삭제 실패: ${_V.postData.file_usage_cd}, Error: ${_V.fetchResponse.data.status.message}`);
                }
            }





            // 모든 작업이 완료되었으면 true 반환
            RTN.isContinue = true;
        } // Close_RTN:




        return RTN;
    }

    async FileUploadR2Chunk(
        iFilesArr: any,
        iBrandId: number,
        iPostData: {
            is_allow_overlap: number;// (필수) 파일 이름 중복 허용 여부 1:허용, 2: 미허용 기본값 1. 허용
            group_id?: number | null;// 그룹 ID
            office_id?: number | null;// 지점 ID
            file_usage_cd: number | null;// (필수) 파일 사용 용도 코드 (erp_sys_cd_detail 테이블 sys_cd_id = 25 참조)
            data_pk: number | null;// (필수) 관련 데이터 PK (예: 스케줄ID, 상담ID 등)
            upload_file_pk?: number | null;// 없는 경우 신규 업로드 / 값이 있는 경우 기존 업로드 파일 PK에 파일을 추가 하는 경우

            is_add?: number; // 1:추가 업로드 (없으면 신규 업로드)
            add_data?: any; // 추가 데이터 (필요한 경우)
        } = {
            is_allow_overlap:   1 ,     // (필수) 파일 이름 중복 허용 여부 1:허용, 2: 미허용 기본값 1. 허용
            file_usage_cd   :   null ,  // (필수) 파일 사용 용도 코드 (erp_sys_cd_detail 테이블 sys_cd_id = 25 참조)
            data_pk         :   null ,  // (필수) 관련 데이터 PK (예: 스케줄ID, 상담ID 등)

            // upload_file_pk  :   null ,  // 없는 경우 신규 업로드
                                        // 값이 있는 경우 기존 업로드 파일 PK에 파일을 추가 하는 경우
            // is_add        :   1 ,     // 1:추가 업로드 (없으면 신규 업로드)
            // add_data      :   null ,  // 추가 데이터 (필요한 경우)
        } ,
        iCallback: {
            onProgress?: Function;
            onAbort?: Function;
        } = {
            onProgress  :   undefined ,
            onAbort     :   undefined ,
        },
        iFilesArrFolderIdArr: number[] = [] ,
        iParallelUnit: number = 5 ,
    ) {
        let RTN: {
            upload_file_pk: number | null;
            fileCount: number;
            fileSizeTotal: number;
            totalFileSize?: number;
            album_save_id?: number;
            uploadedFileInfoArr?: any[];
        } = {
            upload_file_pk : null as (number | null) ,
            fileCount : 0,
            fileSizeTotal : 0,
        };

        const _V: {
            brandId: number;
            filesArr: any;
            fileCount: number;
            filesArrFileAttrArr: any[];
            filesArrFolderIdArr: number[];
            parallelUnit: number;
            postData: {
                brand_id: number;
                group_id?: number | null;
                office_id?: number | null;
                file_usage_cd: number;
                data_pk: number | null;
                upload_file_pk?: number | null;
                is_add?: number | null;
                is_allow_overlap: number;
                add_data: any;
            };
            callback: {
                onProgress?: Function;
                onAbort?: Function;
            };
            uploadedFileCount: number;
            totalFileSize: number;
            totalFileUploadedSize: number;
            uploadFileDetailPkArr: (number | null)[];
            uploadedFileInfoArr: any[];
            uploadedFileCompleteArr: any[];
            fetchResponse: any | null;
            abortController: AbortController;
            tmp: string;
            fetchUploadChunk?: any | null;
            fetchComplete?: any | null;
        } = {
            brandId: iBrandId,
            filesArr: iFilesArr,
            fileCount: 0,
            filesArrFileAttrArr: [],
            filesArrFolderIdArr: iFilesArrFolderIdArr,
            parallelUnit: Math.max(1, iParallelUnit || 10),

            postData : {
                brand_id        :   iBrandId ,
                group_id        :   iPostData.group_id || null ,
                office_id       :   iPostData.office_id || null ,
                file_usage_cd   :   Number(iPostData.file_usage_cd) ,
                data_pk         :   iPostData.data_pk || null ,
                upload_file_pk  :   Number(iPostData.upload_file_pk || 0) ,         /* 업로드파일PK */
                is_add          :   (iPostData.is_add == 1) ? 1 : null ,   /* 1:추가업로드, 그외:새로업로드 */
                is_allow_overlap:   iPostData.is_allow_overlap ,                    /* (필수) 파일 이름 중복 허용 여부 1:허용, 2: 미허용 */
                add_data        :   iPostData.add_data || null ,
            } ,

            callback : iCallback ,

            uploadedFileInfoArr : [] ,      // 업로드된 파일 정보
                                            // [{
                                            //      upload_file_pk      :
                                            //      upload_file_data_arr: [{    아래는 upload_file_data_arr 안에 들어갈 값
                                            //          upload_file_detail_pk	1
                                            //          upload_id               R2에서 전달해주는 ID
                                            //          part_arr :  [ {"ETag": "etag_value1", "PartNumber": 1}, ... ]
                                            //      }, ...]
                                            // }, ...]
            uploadedFileCompleteArr : [] ,  // 업로드 완료된 파일 정보 배열 (각 파일 업로드 완료 API를 호출할 값)

            uploadedFileCount       : 0 ,   // 업로드된 파일 개수
            totalFileSize           : 0 ,   // 전체 업로드 대상 파일 사이즈 합계
            totalFileUploadedSize   : 0 ,   // 전체 업로드된 파일 사이즈 합계
            uploadFileDetailPkArr   : [] ,  // 업로드된 파일 상세 PK 배열 (업로드 완료 후 최종 DB에 완료 등록시 필요)

            fetchResponse : null ,

            // 중단을 위한 AbortController 생성
            abortController : new AbortController() ,

            // 임시 변수
            tmp : "" ,
        };

        // 유효성 검사

        // 업로드할 파일 존재 여부
        if ( this.#isEmpty(_V.filesArr) ) {
            throw new Error("업로드할 파일이 없습니다.");
        }
        if ( !Array.isArray(_V.filesArr) ) {
            throw new Error("업로드할 파일은 배열형식이어야 합니다.");
        }
        // _V.filesArr 내부에는 FileList 또는 File 배열 비어있지 않게 있어야 함
        for ( let i = 0 ; i < _V.filesArr.length ; i++ ) {
            if ( this.#isEmpty( _V.filesArr[i] ) ) {
                throw new Error("업로드할 파일 배열에 빈 값이 있습니다.");
            }
            // FileList 또는 File 배열인지 확인
            if ( !( ( _V.filesArr[i] instanceof FileList )
                ||  ( Array.isArray(_V.filesArr[i]) && _V.filesArr[i].every((iFile: any) => iFile instanceof File) ) ) ) {

                throw new Error("업로드할 파일 배열의 항목은 FileList 또는 File 배열이어야 합니다.");
            }
        }

        // 파일 폴더가 지정된 경우
        if ( !this.#isEmpty( _V.filesArrFolderIdArr ) && Array.isArray(_V.filesArrFolderIdArr) ) {

            // 파일폴더가 지정된 경우 업로드 파일의 배열은 파일폴더의 갯수와 같아야 함
            if ( _V.filesArrFolderIdArr.length != (_V.filesArr.length || 0) ) {
                throw new Error("파일폴더가 지정된 경우에는 업로드 파일의 배열은 파일폴더의 갯수와 같아야 합니다.");
            }

        }





        // 업로드할 파일 개수 계산
        _V.fileCount = _V.filesArr.reduce((iAcc, iCurr) => iAcc + (iCurr?.length || 0), 0);

        // 업로드할 전체 파일 사이즈 계산
        _V.totalFileSize = _V.filesArr.reduce((iAcc, iCurr) => iAcc + Array.from(iCurr).reduce((iSubAcc, iFile: any) => iSubAcc + iFile.size, 0), 0);

        // 업로드 파일 존재 여부
        if ( this.#isEmpty(_V.postData.brand_id) ) {
            throw new Error("지정된 스튜디오 브랜드가 없습니다.");
        }

        // 업로드 파일 존재 여부
        if ( this.#isEmpty(_V.fileCount) ) {
            throw new Error("업로드할 파일이 없습니다.");
        }

        // 파일 사용 용도 코드
        if ( isNaN( _V.postData.file_usage_cd ) ) {
            throw new Error("파일 용도 정보를 확인 하세요.");
        }

        // 데이터 PK
        if ( this.#isEmpty(_V.postData.data_pk) || isNaN( Number(_V.postData.data_pk) ) ) {
            _V.tmp = "";

        switch ( _V.postData.file_usage_cd ) {
            case 1:     // 촬영원본사진
            case 2:     // 고객선택사진
            case 3:     // 후기이벤트사진
            case 4:     _V.tmp = "촬영정보";        break;  // 촬영편집사진
            case 5:     _V.tmp = "상세상품정보";    break;  // 상세상품대표이미지
            case 6:     _V.tmp = "상세상품옵션정보";break;  // 상품옵션이미지
            case 7:     _V.tmp = "촬영상품정보";    break;  // 촬영상품테마이미지
            case 8:     _V.tmp = "직원정보";        break;  // 직원서명
            case 9:                                 break;  // (pass) MMS프리셋
            case 10:    _V.tmp = "계약서정보";      break;  // 계약서
            case 11:    _V.tmp = "상세상품폴더정보";break;  // 상세상품폴더정보
            case 12:                                break;  // (pass) 자동발송MMS
            case 13:    _V.tmp = "테마북내용정보";  break;  // 테마북내용정보
            case 14:                                break;  // (pass) MMS이미지
            default:    _V.tmp = "데이타정보";
        }

            if ( !this.#isEmpty(_V.tmp) ) {
                throw new Error(`${_V.tmp}가 없습니다.`);
            }
        }

        // 파일 이름 중복 허용 여부
        if ( ![1,2].includes( Number(_V.postData.is_allow_overlap) ) ) {
            throw new Error("파일 이름 중복 허용 여부를 설정하세요.");
        }

        // 신규 업로드 파일PK 발급
        if (  _V.postData.is_add != 1 ) {
            // // 업로드 파일PK 요청
            // _V.fetchResponse = await gf_LOCAL_API_FETCH_ASYNC(
            //     _V.csrfToken,
            //     "common_post_api:api_sys_upload_file_insert",
            //     {
            //         post_data : {
            //             brand_id        :   _V.postData.brand_id ,
            //             group_id        :   _V.postData.group_id || null ,
            //             office_id       :   _V.postData.office_id || null ,
            //             file_usage_cd   :   Number(_V.postData.file_usage_cd) ,
            //             data_pk         :   _V.postData.data_pk || null ,
            //             add_data        :   _V.postData.add_data || null ,
            //         }
            //     }
            // );

            const sysUploadFileInsertUrl = "api/v3/common/sys-upload-file-insert";

            const sysUploadFileData = {
                brand_id        :   _V.postData.brand_id ,
                group_id        :   _V.postData.group_id || null ,
                office_id       :   _V.postData.office_id || null ,
                file_usage_cd   :   Number(_V.postData.file_usage_cd) ,
                data_pk         :   _V.postData.data_pk || null ,
                add_data        :   _V.postData.add_data || null ,
            }

            _V.fetchResponse = await callAxios.api({
                url: sysUploadFileInsertUrl,
                method: "post",
                data: sysUploadFileData,
            });

            // LocalApiFetchResultProcess(_V.fetchResponse, false);

            if (_V.fetchResponse.status != 200) {
                throw new Error(`업로드 파일PK 요청 실패`);
            }

            if(_V.fetchResponse.data.status.code != 200){
                throw new Error(`업로드 파일PK 요청 실패 Error: ${_V.fetchResponse.data.status.message}`);
            }

            // 업로드 파일PK 설정
            _V.postData.upload_file_pk = _V.fetchResponse.data.result.upload_file_pk;

            _V.fetchResponse = null;

        }

        // 업로드 파일PK 설정
        RTN.upload_file_pk = _V.postData.upload_file_pk || null;

        if (this.#isEmpty(RTN.upload_file_pk) ) {
            throw new Error("업로드 파일 PK 정보가 없습니다.");
        }

        // 프리사인 요청
        for ( let idxFilesArr = 0 ; idxFilesArr < _V.filesArr.length ; idxFilesArr++ ) {
            // 각 파일 배열 처리
            const _files = _V.filesArr[idxFilesArr];
            const _folderId = ( !this.#isEmpty( _V.filesArrFolderIdArr ) ? Number( _V.filesArrFolderIdArr[idxFilesArr] ) : null );
            const _fileList = Array.from(_files).map((iFile: any, iIndex: number) => {
                return {
                    file_index  :   iIndex ,
                    file_name   :   iFile.name ,
                    file_size   :   iFile.size ,
                    folder_id   :   _folderId ,
                };
            });

            if ( _fileList.length == 0 ) {
                continue;
            }





            // 업로드 프리사인 요청 중
            if (_V.callback.onProgress) {
                _V.callback.onProgress({
                    processCode : "CALL_PRESIGNED" ,
                    processMessage : "업로드 Url 요청 중..." ,
                });
            }

            // 시간 측정
            console.time(">>>> presigned 요청 시간 측정");

            // // 프리사인 요청
            // _V.fetchResponse = await gf_LOCAL_API_FETCH_ASYNC(
            //     _V.csrfToken,
            //     "common_post_api:api_multi_part_upload_presigned",
            //     {
            //         post_data : {
            //             brand_id            :   _V.postData.brand_id ,          /* (필수) 브랜드 ID */
            //             upload_file_pk      :   _V.postData.upload_file_pk ,    /* (필수) 업로드파일PK */
            //             is_allow_overlap    :   _V.postData.is_allow_overlap ,  /* (필수) 파일 이름 중복 허용 여부 1:허용, 2: 미허용 */
            //             file_usage_cd       :   _V.postData.file_usage_cd ,     /* (필수) 파일 업로드 타입 */
            //             data_pk             :   _V.postData.data_pk ,           /* (필수) 업로드 할 파일 타입의 master pk 원본 : 스케줄 아이디 */
            //             is_add              :   _V.postData.is_add ,            /* (필수) 1:추가업로드, 그외:새로업로드 */
            //             file_list           :   _fileList ,                     /* (필수) 파일 목록 */
            //         } ,
            //     }
            // );

            const multiPartUploadPresignedUrl = "api/v3/common/multi-part-upload-presigned";

            _V.fetchResponse = await callAxios.api({
                url: multiPartUploadPresignedUrl,
                method: "post",
                data: {
                    brand_id            :   _V.postData.brand_id ,          /* (필수) 브랜드 ID */
                    upload_file_pk      :   _V.postData.upload_file_pk ,    /* (필수) 업로드파일PK */
                    is_allow_overlap    :   _V.postData.is_allow_overlap ,  /* (필수) 파일 이름 중복 허용 여부 1:허용, 2: 미허용 */
                    file_usage_cd       :   _V.postData.file_usage_cd ,     /* (필수) 파일 업로드 타입 */
                    data_pk             :   _V.postData.data_pk ,           /* (필수) 업로드 할 파일 타입의 master pk 원본 : 스케줄 아이디 */
                    is_add              :   _V.postData.is_add ,            /* (필수) 1:추가업로드, 그외:새로업로드 */
                    file_list           :   _fileList ,                     /* (필수) 파일 목록 */
                } ,
            });

            // 측정된 시간 표시
            console.timeEnd(">>>> presigned 요청 시간 측정");

            // gf_LOCAL_API_FETCH_RESULT_PROCESS(_V.fetchResponse, false);






            /*
                {
                    "file_index" : 1 ,
                    "upload_file_pk": 18788,
                    "upload_file_detail_pk": 1068077,
                    "upload_id": "AP33SUGmJNqBvJFFNLpVrmW-9UJtcCRvVOGQUqbiGc_PcCC0Gsctvtk9nTE3emAxV5_6AfXmAhm4bOl_pJ72x06oSO3oIRtuBZIoB5-mWaNFTw6QEDvHL_s6LyQ6mHsqcW6cTm1e-qdJo-vCvSImpA7F9J6bFsGhqKhVhO-d02eBe94UMCo0Vq3T94vGeYHoPt-1cX2d7y7M0mXxmdR_Xp_gKYs66j6soIlbTqZJfXJv2BfURH42I-mO_spafFq3bf8_ptixtCdtKg-Hpj4vIv6J-knm-lw5yxkZOIanto7PQoSvsrgV8nYE5Hcz6k_b7tZCeE5jCy512quGA85MVww",
                    "chunk_count": 1,
                    "size_per_chunk": 10485760,
                    "file_upload_url": {
                        "1": "https://b2001cf1b9a5aaa314f5e84444a4fe9e.r2.cloudflarestorage.com/lmedrp/real/1/office/4/customers/202602/1224566/schedules/724909/before/%EB%82%A8%EB%A7%A4%20%285%29.JPG?uploadId=AP33SUGmJNqBvJFFNLpVrmW-9UJtcCRvVOGQUqbiGc_PcCC0Gsctvtk9nTE3emAxV5_6AfXmAhm4bOl_pJ72x06oSO3oIRtuBZIoB5-mWaNFTw6QEDvHL_s6LyQ6mHsqcW6cTm1e-qdJo-vCvSImpA7F9J6bFsGhqKhVhO-d02eBe94UMCo0Vq3T94vGeYHoPt-1cX2d7y7M0mXxmdR_Xp_gKYs66j6soIlbTqZJfXJv2BfURH42I-mO_spafFq3bf8_ptixtCdtKg-Hpj4vIv6J-knm-lw5yxkZOIanto7PQoSvsrgV8nYE5Hcz6k_b7tZCeE5jCy512quGA85MVww&partNumber=1&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=168b01c8ba4c49a6311b176b5b14774d%2F20260204%2Fauto%2Fs3%2Faws4_request&X-Amz-Date=20260204T031303Z&X-Amz-Expires=600&X-Amz-SignedHeaders=host&X-Amz-Signature=8789b7c14c14d94c61b88e8cfa944e5206b17ff94adf3ec76bc0806ed31ab89d"
                    }
                }
            */

            // 프리사인 요청 결과 배열에 추가 (프리사인 경과 정보 : _V.filesArrFileAttrArr)

            if (  _V.fetchResponse.data?.result?.length > 0 ) {
                _V.filesArrFileAttrArr[idxFilesArr] = [];

                for (let idxFile=0; idxFile < _V.fetchResponse.data.result.length; idxFile++ ) {
                    // filesArrFile의 정보를 filesArrFileAttrArr에서 파일 인덱스로 빠르게 접근하기 위해 파일 인덱스를 키로 사용
                    _V.filesArrFileAttrArr[idxFilesArr][ _V.fetchResponse.data.result[idxFile].file_index ] = {
                        presigned : _V.fetchResponse.data.result[idxFile] ,
                        folder_id : _folderId ,
                    };
                }

            } // if ( _V.fetchResponse.data.length > 0 )





            _V.fetchResponse = null;
        }

        // 모든 파일을 Promise Pool 방식으로 업로드 (동적 병렬 처리)
        for ( let i = 0 ; i < _V.filesArr.length ; i++ ) {
            // 각 파일 배열 처리
            const _files = _V.filesArr[i];
            const _fileAttrArr = _V.filesArrFileAttrArr[i];

            // 파일 업로드 태스크 생성
            const uploadTasks = Array.from(_files).map((iFile: any, idxFile: number) => {
                const _fileAttr = _fileAttrArr[idxFile];

                return () => uploadSingleFile(iFile, idxFile, _fileAttr);
            });

            // Promise Pool 방식으로 업로드 실행
            await promisePool(uploadTasks, _V.parallelUnit);
        }

        if ( this.#isEmpty(RTN.upload_file_pk) ) {

            // 업로드 실패

            RTN.upload_file_pk = null;
            RTN.fileCount = 0;
            RTN.totalFileSize = 0;
            RTN.album_save_id = 0;
            RTN.uploadedFileInfoArr = [];

        } else {

            // 업로드 청크 처리 시작
            if (_V.callback.onProgress) {
                _V.callback.onProgress({
                    processCode : "UPLOAD_CHUNK_COMPLETE_START" ,
                    processMessage : "업로드 파일 합치는 중..." ,
                });
            }

            // // 각 파일 완료요청
            // _V.fetchComplete = await gf_LOCAL_API_FETCH_ASYNC(
            //     _V.csrfToken,
            //     "common_post_api:api_multi_part_upload_complete",
            //     {
            //         post_data: {
            //             upload_file_pk          :   RTN.upload_file_pk ,
            //             upload_file_data_arr    :   _V.uploadedFileCompleteArr ,
            //         }
            //     }
            // );
            // const multiPartUploadCompleteUrl = "api/v3/common/multi-part-upload-complete";
            const multiPartUploadCompleteUrl = "api/v3/common/file-upload-complete";
            const multiPartUploadCompleteData = {
                upload_file_pk          :   RTN.upload_file_pk ,
                upload_file_data_arr    :   _V.uploadedFileCompleteArr ,
            }

            dev_console.log("multiPartUploadCompleteData ============");
            dev_console.log(multiPartUploadCompleteData);
            dev_console.log("================================================");

            _V.fetchComplete = await callAxios.api({
                url: multiPartUploadCompleteUrl,
                method: "post",
                data: multiPartUploadCompleteData,
            });

            if (_V.fetchComplete.status != 200) {
                throw new Error(`업로드 완료 요청 실패`);
            }

            if(_V.fetchComplete.data.status.code != 200){
                throw new Error(`업로드 완료 요청 실패 Error: ${_V.fetchComplete.data.status.message}`);
            }

            // gf_LOCAL_API_FETCH_RESULT_PROCESS(_V.fetchComplete, false);


            // 업로드 완료 등록 처리 시작
            if (_V.callback.onProgress) {
                _V.callback.onProgress({
                    processCode : "UPLOAD_COMPLETE_DB_SAVE_START" ,
                    processMessage : "업로드 완료 등록 처리 중..." ,
                });
            }

            // // R2 업로드 후 DB에 정보 저장
            // _V.fetchResponse = await gf_LOCAL_API_FETCH_ASYNC(
            //     _V.csrfToken,
            //     "common_post_api:api_file_data_insert",
            //     {
            //         post_data: {
            //             upload_file_pk  :   RTN.upload_file_pk ,
            //             is_add          :   _V.postData.is_add ,
            //             upload_file_detail_pk_arr : _V.uploadFileDetailPkArr ,
            //             add_data        :   _V.postData.add_data ,
            //         }
            //     }
            // );

            const fileDataInsertUrl = "api/v3/common/file-data-insert";

            const fileDataInsertData = {
                upload_file_pk  :   RTN.upload_file_pk ,
                is_add          :   _V.postData.is_add ,
                upload_file_detail_pk_arr : _V.uploadFileDetailPkArr ,
                add_data        :   _V.postData.add_data ,
            }

            _V.fetchResponse = await callAxios.api({
                url: fileDataInsertUrl,
                method: "post",
                data: fileDataInsertData
            });

            // gf_LOCAL_API_FETCH_RESULT_PROCESS(_V.fetchResponse, false);

            dev_console.log("fileDataInsertResponse ============");
            dev_console.log(_V.fetchResponse);
            dev_console.log("================================================");

            if (_V.fetchResponse.status != 200) {
                throw new Error(`업로드 완료 등록 요청 실패`);
            }

            if(_V.fetchResponse.data.status.code != 200){
                throw new Error(`업로드 완료 등록 요청 실패 Error: ${_V.fetchResponse.data.status.message}`);
            }

            // 전체 파일 사이즈 설정
            RTN.totalFileSize = _V.totalFileSize;
            // 업로드된 파일 정보 설정
            RTN.uploadedFileInfoArr = _V.uploadedFileInfoArr;

            RTN.album_save_id = _V.fetchResponse.data.result.album_save_id || null;
        }

        return RTN;

        // 각 파일 업로드를 비동기적으로 동시에 실행하기 위한 함수 정의
        async function uploadSingleFile(iFile: File, iIndex: number, iFileAttr: any) {

            try {

                const _P: {
                    file: File;
                    presigned: any;
                    chunkCount: number;
                    sizePerChunk: number;
                    uploadFilePk: number | null;
                    uploadFileDetailPk: number | null;
                    uploadId: string | null;
                    uploadedFileDataArr: any[];
                    uploadedFilePartArr: any[];
                    postDataChuckUploadCall: {
                        upload_file_pk: number | null;
                        upload_file_data_arr: any[];
                    };
                    fetchPresigned: any;
                    fetchUploadChunk: any;
                    fetchComplete: any;
                } = {
                    file                :   iFile ,
                    presigned           :   iFileAttr.presigned || null ,
                    chunkCount          :   iFileAttr.presigned?.chunk_count || 0 ,
                    sizePerChunk        :   iFileAttr.presigned?.size_per_chunk || 0 ,
                    uploadFilePk        :   iFileAttr.presigned?.upload_file_pk || null ,       // 프리사인 발급 결과의 upload_file_pk를 전달 (파일이 여러개 일때 같은 묶음을 위한 값)
                    uploadFileDetailPk  :   iFileAttr.presigned?.upload_file_detail_pk || null ,// 프리사인 발급 결과의 upload_file_detail_pk를 전달 (각 파일의 고유한 값)
                    uploadId            :   iFileAttr.presigned?.upload_id || null ,            // 프리사인 발급 결과의 upload_id

                    uploadedFileDataArr :   [] ,    // 업로드된 다중 파일 데이터 배열
                                                    // [{
                                                    //     upload_file_detail_pk
                                                    //     upload_id    : -R2에서 전달해주는 ID
                                                    //     part_arr     : [ {"ETag": "etag_value1", "PartNumber": 1}, ... ]
                                                    // }... ]
                    uploadedFilePartArr :   [] ,    // 업로드된 청크 파트 배열
                                                    // [ {"ETag": "etag_value1", "PartNumber": 1}, ... ]

                    postDataChuckUploadCall : {
                        upload_file_pk       :   iFileAttr.presigned?.upload_file_pk || null ,  // 프리사인 발급 결과의 upload_file_pk를 전달 (파일이 여러개 일때 같은 묶음을 위한 값)
                        upload_file_data_arr :  [] ,    // 업로드 완료 다중 파일 데이터 배열
                                                        // [{
                                                        //     upload_file_detail_pk
                                                        //     upload_id    : -R2에서 전달해주는 ID
                                                        //     part_arr     : [ {"ETag": "etag_value1", "PartNumber": 1}, ... ]
                                                        // }... ]
                    } ,

                    fetchPresigned : null ,
                    fetchUploadChunk : null ,
                    fetchComplete : null ,
                };

                // // 프리사인 요청
                // _P.fetchPresigned = await LocalApiFetchAsync(
                //     _V.csrfToken,
                //     "common_api:api_multi_part_upload_presigned",
                //     { qs_required: _P.qsPresignedCall }
                // );

                if ( (_P.presigned?.chunk_count || 0) <= 0 ) {
                    throw new Error(`업로드 프리사인 정보 오류 (chunk_count) : ${_P.file.name}`);
                }
                if ( _P.presigned.chunk_count != Object.keys( _P.presigned?.file_upload_url || {} ).length ) {
                    throw new Error(`업로드 프리사인 정보 오류 (chunk_count) : ${_P.file.name}`);
                }
                if ( (_P.presigned?.size_per_chunk || 0) <= 0 ) {
                    throw new Error(`업로드 프리사인 정보 오류 (size_per_chunk) : ${_P.file.name}`);
                }

                // 청크 업로드 (파일 내 청크는 순차 혹은 병렬 선택 가능, 여기서는 순차 유지)
                for (let idxChunk = 1; idxChunk <= _P.presigned.chunk_count; idxChunk++) {
                    const _uploadUrl = _P.presigned?.file_upload_url[idxChunk];
                    const _body = _P.file.slice((idxChunk - 1) * _P.presigned.size_per_chunk, idxChunk * _P.presigned.size_per_chunk);

                    try{

                        _V.fetchUploadChunk = await fetch(_uploadUrl, {
                            method  : "PUT" ,
                            headers : { "Content-Type": "multipart/form-data" } ,
                            body    : _body ,
                            signal  : _V.abortController.signal ,  // 업로드 중단 신호 연결
                        });

                        if (_V.fetchUploadChunk.status != 200) {
                            throw new Error(`업로드 실패: ${_P.file.name}, Part: ${idxChunk}`);
                        }

                        // 업로드된 청크 파트 정보 저장 (업로드된 파일 정보 기록에 필요)
                        _P.uploadedFilePartArr.push({
                            ETag: _V.fetchUploadChunk.headers.get("ETag"),
                            PartNumber: idxChunk
                        });

                    }catch(error: any){
                        dev_console.error(error);
                    }




                    _V.totalFileUploadedSize += _body.size;

                    // 청크 업로드 진행 콜백 호출
                    if (_V.callback.onProgress) {
                        _V.callback.onProgress({
                            processCode : "UPLOADING" ,
                            processMessage : "파일 업로드 중..." ,

                            fileIndex: iIndex,
                            fileName: _P.file.name,
                            fileSize: _P.file.size,
                            uploadedFileCount : _V.uploadedFileCount,
                            totalFileCount: _V.fileCount,
                            totalFileUploadedSize: _V.totalFileUploadedSize,
                            totalFileSize: _V.totalFileSize
                        });
                    }
                } // for (let i = 1; i <= _P.chunkCount; i++) {





                // 업로드된 파일 개수
                _V.uploadedFileCount += 1;
                // 업로드된 파일 상세 PK 배열에 추가
                _V.uploadFileDetailPkArr.push( _P.uploadFileDetailPk );

                // 업로드된 파일 정보 배열에 추가
                _V.uploadedFileInfoArr.push({
                    file_index              :   _P.presigned.file_index ,
                    file_name               :   _P.file.name ,
                    file_size               :   _P.file.size ,
                    upload_file_detail_pk   :   _P.uploadFileDetailPk ,
                    file_hash               :   await getFileHash( _P.file ) ,
                });

                // 업로드 완료된 파일 정보 배열 (각 파일 업로드 완료 API를 호출할 값)
                _V.uploadedFileCompleteArr.push({
                    upload_file_detail_pk   :   _P.uploadFileDetailPk ,
                    upload_id               :   _P.uploadId ,
                    part_arr                :   _P.uploadedFilePartArr ,
                });




                // 1개 파일 업로드 완료 됐을때 콜백 호출
                if (_V.callback.onProgress) {
                    _V.callback.onProgress({
                        processCode : "UPLOADING" ,
                        processMessage : "파일 업로드 중..." ,

                        fileIndex: iIndex,
                        fileName: _P.file.name,
                        fileSize: _P.file.size,
                        uploadedFileCount : _V.uploadedFileCount,
                        totalFileCount: _V.fileCount,
                        totalFileUploadedSize: _V.totalFileUploadedSize,
                        totalFileSize: _V.totalFileSize
                    });
                }

            } catch ( iError ) {

                _V.abortController.abort();  // 오류 발생시 모든 업로드 중단
                throw iError;

            }

        } // const uploadSingleFile = async (iFile, iIndex) => {

    } // async function gf_FILE_UPLOAD_S3(

    async FileDataClear(
        {
            ...props
        }:{
            brand_id: number;

            upload_file_pk?: number;
            upload_file_detail_pk?: number;

            file_usage_cd?: number;
            data_pk?: number;

            is_all_clear: 1 | 2; // 1 - 모두 삭제, 2 - 일부 삭제
        }
    ){
        let RTN = {
            isContinue: false,
            message: "",
        };

        try{
            const originUrl = "api/v3/common/file-data-delete";

            dev_console.log(originUrl);
            dev_console.log(props);

            const result = await callAxios.api({
                url: originUrl,
                method: "post",
                data: props,
            });

            dev_console.log(result);

            if(result.status != 200){
                throw new Error(`파일 데이터 삭제 실패`);
            }

            if(result.data.status.code != 200){
                throw new Error(`파일 데이터 삭제 실패: ${result.data.status.message}`);
            }

            RTN.isContinue = true;
        }catch(error: any){
            RTN.message = error.message;
        }

        return RTN;
    }

        // /**
    //  *  값이 비어 있는지 확인
    //  *
    //  *  @author Bruce.Cheong    2025-07-27
    //  *
    //  *  @param   {any}    iValue      - 검사할 값
    //  *  @param   {Array}  iNotEmptyValue - 비어 있지 않은 값의 배열 (선택적)
    //  *
    //  *  @returns {boolean} - 값이 비어 있으면 true, 그렇지 않으면 false
    //  */
    #isEmpty(iValue: any, iNotEmptyValue: any[] = []): boolean {

        let RTN: boolean = (iValue === null) || (iValue === undefined) || (iValue === false);

        const _V ={
            valueType: typeof iValue,
        } as { valueType: string };

        Close_RTN: {
            // iValue가 이미 비어 있으면 빠져나감
            if ( RTN ) {
                break Close_RTN;
            }

            // iValue가 비어 있지 않은 경우, 타입에 따라 검사
            switch (_V.valueType) {
                case "string":
                    RTN = (iValue.trim() == "") || (iValue.trim() == "0") || (iValue.trim().toLowerCase() === "nan") || (iValue.trim().toLowerCase() === "undefined");
                    break Close_RTN;
                case "number":
                case "bigint":
                    RTN = Number.isNaN(iValue) || (iValue == 0);
                    break Close_RTN;
                case "object":

                    // 2026.01.20 - 김효민 - react환경에서는 jquery를 사용하지 않음
                    // if ( iValue instanceof jQuery ) {
                    //     // jQuery 객체인 경우
                    //     RTN = iValue.length == 0;
                    // } else

                    if ( iValue instanceof Date ) {
                        // Date 객체인 경우, 유효하지 않은 날짜(Invalid Date)를 '비어있음'으로 간주
                        RTN = isNaN(iValue.getTime());
                    } else if ( iValue instanceof File ) {
                        // File 객체인 경우
                        RTN = iValue.size == 0;
                    } else if ( iValue instanceof FileList ) {
                        // FileList 객체인 경우
                        RTN = iValue.length == 0;
                    } else if ( iValue instanceof Map ) {
                        // Map 객체인 경우
                        RTN = iValue.size == 0;
                    } else if ( iValue instanceof Set ) {
                        // Set 객체인 경우
                        RTN = iValue.size == 0;
                    } else if ( iValue instanceof FormData ) {
                        // FormData 객체인 경우 (ES6)
                        RTN = [...iValue.keys()].length === 0;
                    } else if ( iValue instanceof URLSearchParams ) {
                        // URLSearchParams 객체인 경우 (ES6)
                        RTN = [...iValue.keys()].length === 0;
                    } else if ( iValue instanceof HTMLElement ) {
                        // HTML 요소인 경우
                        // 2026.01.20 - 김효민 - iValue.value는 존재하지 않는다는 타입 에러 발생
                        RTN = this.#isEmpty(iValue.innerText as string || "");
                    } else if ( Array.isArray(iValue) ) {
                        // 배열인 경우
                        RTN = iValue.length == 0;
                    } else {
                        // 일반 객체가 비어 있는지 확인
                        RTN = Object.keys(iValue).length == 0;
                    }

                    break Close_RTN;
                case "boolean":
                default:
                    return !!iValue;
            }
        }





        // 비어 있지 않은 값의 배열이 제공된 경우, 해당 값이 포함되어 있는지 확인
        if ( RTN && iNotEmptyValue.length > 0 ) {
            RTN = !iNotEmptyValue.some(value => value === iValue);
        }





        return RTN;
    } // function gf_IS_EMPTY

    // /**
    //  *  두 날짜 사이의 차이를 계산
    //  *
    //  *  @author Bruce.Cheong    2025-07-27
    //  *
    //  *  @param   {string|Date}  iDate1 - 첫 번째 날짜 (ISO 문자열 또는 Date 객체) (기본값 = 오늘)
    //  *  @param   {string|Date}  iDate2 - 두 번째 날짜 (ISO 문자열 또는 Date 객체) (기본값 = 오늘)
    //  *  @param   {boolean}      iIsPlus1IfPositive - (차이가 양수일 때) 차이에 1을 더할지 여부 (기본값 = false) (시작일을 1일로 포함할 때 사용)
    //  *  @param   {string}       iUnit - 차이 단위 (예: "day", "month", "year") (기본값 = "day")
    //  *
    //  *  @returns {number|boolean} - 두 날짜 사이의 차이 (단위: iUnit) 또는 false (날짜가 유효하지 않거나 dayjs 라이브러리가 없을 경우)
    //  */
    #DateDiff(iDate1: Date | string | number | Dayjs, iDate2: Date | string | number | Dayjs | null, iIsPlus1IfPositive: boolean = false, iUnit: string = "day") {
        let RTN: number | false = false;
        const _V = {
            date1               :   iDate1,
            date2               :   iDate2,
            iIsPlus1IfPositive   :   !!iIsPlus1IfPositive,
            unit                :   iUnit,
        };
        Close_RTN: {
            // dayjs가 정의되어 있지 않으면 빠져나감
            if ( typeof dayjs === "undefined" ) {
                console.error("gf_DATE_DIFF: dayjs library가 Import 되지 않았음.");
                break Close_RTN;
            }
            // date1이 지정되어 있지 않으면 오늘 날짜로 설정 (Bruce.Cheong 2025-11-07)
            // 기존에는 빈값인지 확인을 했는데 그럼 실제로 없는 날짜가 오늘로 셋팅되는 문제가 있음.
            if ( (_V.date1 === undefined) || (_V.date1 === null) )  { _V.date1 = dayjs(); }
            else                                                    { _V.date1 = dayjs(_V.date1); }
            // date2가 지정되어 있지 않으면 오늘 날짜로 설정 (Bruce.Cheong 2025-11-07)
            // 기존에는 빈값인지 확인을 했는데 그럼 실제로 없는 날짜가 오늘로 셋팅되는 문제가 있음.
            if ( (_V.date2 === undefined) || (_V.date2 === null) )  { _V.date2 = dayjs(); }
            else                                                    { _V.date2 = dayjs(_V.date2); }
            // 날짜가 유효하지 않으면 빠져나감
            if ( !_V.date1.isValid() || !_V.date2.isValid() ) {
                break Close_RTN;
            }
            // 날짜 차이를 계산
            RTN = _V.date2.diff(_V.date1, _V.unit as any);
            // iIsPlus1IfDay이 true이면 1을 더함 (날짜가 양수일 때)
            // if ( _V.iIsPlus1IfDay && (_V.unit === "day") && (RTN >= 0) ) {
            if ( _V.iIsPlus1IfPositive && (RTN >= 0) ) {
                RTN += 1;
            }
        }
        return RTN;
    }

    // /**
    //  *  날짜를 지정된 형식으로 변환
    //  *
    //  *  @author Bruce.Cheong    2025-07-27
    //  *
    //  *  @param   {Date|string|number} iDate - 변환할 날짜 (Date 객체, ISO 문자열, 또는 타임스탬프) (기본값 = 오늘)
    //  *  @param   {string} iFormat - 날짜 형식 (기본값 "YYYY-MM-DD")
    //  *  @param   {Date|string|number} iMinDate - 최소 날짜 (선택적, 유효성 검사용)
    //  *  @param   {Date|string|number} iMaxDate - 최대 날짜 (선택적, 유효성 검사용)
    //  *
    //  *  @returns {string|boolean} - 변환된 날짜 문자열 또는 false (날짜가 유효하지 않거나 dayjs 라이브러리가 없을 경우)
    //  */
    #DateFormat(iDate: Date | string | number | Dayjs, iFormat: string | null = "YYYY-MM-DD", iMinDate: Date|string|number|null|boolean = null, iMaxDate: Date|string|number|null|boolean = null) {

        let RTN: string | false = false;

        const _V = {
            date    :   iDate ,
            format  :   iFormat ,
            minDate :   iMinDate ,
            maxDate :   iMaxDate ,
        };

        Close_RTN: {
            // dayjs가 정의되어 있지 않으면 빠져나감
            if ( typeof dayjs === "undefined" ) {
                console.error("gf_DATE_FORMAT: dayjs library가 Import 되지 않았음.");
                break Close_RTN;
            }

            // date가 지정되어 있지 않으면 오늘 날짜로 설정 (Bruce.Cheong 2025-10-22)
            // 기존에는 빈값인지 확인을 했는데 그럼 실제로 없는 날짜가 오늘로 셋팅되는 문제가 있음.
            // if ( gf_IS_EMPTY(_V.date) ) { _V.date = dayjs(); }
            if ( (_V.date === undefined) || (_V.date === null) )    { _V.date = dayjs(); }
            else                                                    { _V.date = dayjs(_V.date); }

            // 날짜가 유효하지 않으면 빠져나감
            if ( !_V.date.isValid() ) {
                break Close_RTN;
            }

            // 최소 날짜가 유효하면 비교
            if ( _V.minDate && !this.#isEmpty(_V.minDate) ) {
                const minDate = dayjs(_V.minDate as Date | string | number | Dayjs);
                if ( !minDate.isValid() || _V.date.isBefore(minDate) ) {
                    console.error("gf_DATE_FORMAT: 날짜가 최소 날짜보다 이전입니다.");
                    break Close_RTN;
                }
            }

            // 최대 날짜가 유효하면 비교
            if ( _V.maxDate && !this.#isEmpty(_V.maxDate) ) {
                const maxDate = dayjs(_V.maxDate as Date | string | number | Dayjs);
                if ( !maxDate.isValid() || _V.date.isAfter(maxDate) ) {
                    console.error("gf_DATE_FORMAT: 날짜가 최대 날짜보다 이후입니다.");
                    break Close_RTN;
                }
            }

            // 날짜를 지정된 형식으로 변환
            RTN = _V.date.format(iFormat as string);
        }

        return RTN;
    }

    // /**
    //  * 비동기 동시 실행 제한 함수 (Concurrency Control)
    //  * * @author Bruce.Cheong 2026-01-20 (김효민 2026-01-20)
    //  * @param {Array} iArray - 처리할 데이터 배열
    //  * @param {number} iLimit - 동시 실행 제한 수 (예: 3)
    //  * @param {Function} iIteratorFn - 실행할 비동기 함수 (item, index) => Promise
    // */
    async #AsyncPool(iArray: any[], iLimit: number, iIteratorFn: (item: any, index: number) => Promise<any>) {
        const _ret: Promise<any>[] = [];      // 모든 작업의 프로미스를 저장할 배열 (결과 순서 보장용)
        const _executing: Promise<any>[] = []; // 현재 실행 중인 프로미스만 담을 배열

        for (const [index, item] of iArray.entries()) {
            // 1. 작업을 생성하고 실행 (Promise.resolve로 감싸서 즉시 실행)
            const p = Promise.resolve().then(() => iIteratorFn(item, index));
            _ret.push(p);

            // 2. 실행 목록(_executing)에 등록하되, 완료되면 목록에서 스스로 제거하는 로직 추가
            if (iLimit <= iArray.length) {
                const e: Promise<any> = p.then(() => _executing.splice(_executing.indexOf(e), 1));
                _executing.push(e);

                // 3. 실행 중인 개수가 제한(Limit)에 도달하면,
                //    실행 목록 중 하나라도 끝날 때까지 대기 (Promise.race)
                if (_executing.length >= iLimit) {
                    await Promise.race(_executing);
                }
            }
        }

        // 4. 모든 작업이 생성되었으므로, 나머지 작업들이 모두 끝날 때까지 대기
        return Promise.all(_ret);
    } // gf_ASYNC_POOL(iArray, iLimit, iIteratorFn) {
}


export const printFormData = (fromdata: FormData) => {
    for (let [key, value] of fromdata.entries()) {
        dev_console.log(`${key}: ${value}`);
    }
}

export const isNotPrintModeView = () => {
    return process.env.REACT_APP_NO_PRINT_MODE_VIEW === "TRUE";
}

class whoAmIClass{
    getAccountData: getAccountDataClass

    constructor(){
        this.getAccountData = new getAccountDataClass();
    }

    isAllEnAbleUser(): boolean{
        return (this.getAccountData.user_type() === "C" || this.getAccountData.user_type() === "E" || this.getAccountData.user_type() === "O")
    }

    isCustomer(): boolean{
        return (this.getAccountData.user_type() === "C" && !!this.getAccountData.token())
    }

    isAdmin(): boolean{
        return (this.getAccountData.user_type() === "E" && !!this.getAccountData.token())
    }

    isNomalEmployee(): boolean{
        return (this.getAccountData.user_type() === "O" && !!this.getAccountData.token())
    }

    isAllEmployee(): boolean{
        return (this.getAccountData.user_type() === "E" || this.getAccountData.user_type() === "O")
    }
}
export const whoAmI = new whoAmIClass();

interface customToastMethodInterface{
    msg: string,
    toastId?: string,
    autoClose?: number | false
}

class customToastClass{

    info({msg, toastId, autoClose = TOAST_AUTO_CLOSE}: customToastMethodInterface){
        if(!!toastId && toast.isActive(toastId)){
            toast.update(toastId, {
                render: msg,
            });
        }else{
            toast.info(msg, {
                toastId,
                autoClose,
            });
        }
    }

    success({msg, toastId, autoClose = TOAST_AUTO_CLOSE}: customToastMethodInterface){
        if(!!toastId && toast.isActive(toastId)){
            toast.update(toastId, {
                render: msg,
            });
        }else{
            toast.success(msg, {
                toastId,
                autoClose,
            });
        }
    }

    error({msg, toastId, autoClose = TOAST_AUTO_CLOSE}: customToastMethodInterface){
        if(!!toastId && toast.isActive(toastId)){
            toast.update(toastId, {
                render: msg,
            });
        }else{
            toast.error(msg, {
                toastId,
                autoClose,
            });
        }
    }
}

export const customToast = new customToastClass();

// 주소가 어느 지역에 속하는지 확인하는 함수
export const findRegionByAddress = (address: string): regionInterface | null => {
    // 주소에서 시, 구, 군 명칭을 우선으로 처리합니다.
    for (const region of REGION_LIST) {
        const cities = region.cities;
        for (const city of cities) {
            // 시/구/군 단위가 포함된 경우 해당 지역으로 반환
            if (address.includes(city)) {
                return region;
            }
        }
    }
    return null; // 어느 지역에도 속하지 않는 경우
}

// 다운로드에 걸리는 예상시간을 리턴해줌
export function estimateDownloadTime({
    kilobytes,
}:{
    kilobytes: number;
}): number {
    const mb_per_sec = 1024 / 180; // 1GB를 180초(3분)에 받는 속도

    if (kilobytes < 0) {
        dev_console.error("파일의 용량은 음수일 수 없습니다.");
        return 0;
    }

    const fileSizeInMB = kilobytes / 1024; // KB → MB 변환
    const timePerMB = 1 / mb_per_sec;
    const totalSeconds = fileSizeInMB * timePerMB;

    if (totalSeconds < 60) {
        return 1; // 최소 1분 보장
    }

    return Math.ceil(totalSeconds / 60); // 분 단위로 올림
}

// kilobytes 단위의 파일 용량을 적절한 단위로 변환해주는 함수
export function formatFileSize({
    kilobytes,
}:{
    kilobytes: number;
}): string {
    if (kilobytes < 0) return '0 KB'; // 음수 방어
    if (kilobytes === 0) return '0 KB';

    const base = 1000;
    const units = ['KB', 'MB', 'GB'];

    let value = kilobytes;
    let unitIndex = 0;

    while (value >= base && unitIndex < units.length - 1) {
      value = value / base;
      unitIndex++;
    }

    const rounded = value.toFixed(2); // 소수점 2째자리까지 반올림
    return `${rounded} ${units[unitIndex]}`;
}

// 20250620 - 김효민 - 구식 함수로 삭제 예정
// 키로바이트를 메가바이트로 변환해주는 함수
export function kilobytesToMB(kilobytes: number): number {
    const KB_IN_MB = 1024; // 1MB는 1024KB
    if (kilobytes < 0) {
        throw new Error("킬로바이트 값은 음수일 수 없습니다.");
    }
    const mbValue = kilobytes / KB_IN_MB;
    return Math.round(mbValue * 100) / 100; // 소숫점 둘째 자리에서 반올림
}

// 20250620 - 김효민 - 구식 함수로 삭제 예정
// 키로바이트를 적절한 단위 (KB, MB, GB)로 변환해주는 함수
export function bytesToFormattedSize(kb: number): string {
    const KB_IN_MB = 1024; // 1MB는 1024KB
    const MB_IN_GB = 1024; // 1GB는 1024MB

    if (kb < 0) {
        throw new Error("바이트 값은 음수일 수 없습니다.");
    }

    // 1MB보다 작으면 KB로 반환
    if (kb < KB_IN_MB) {
        return `${kb}KB`;
    }

    // 1MB 이상 1GB 미만이면 MB로 반환
    const mbValue = kb / KB_IN_MB;
    if (mbValue < MB_IN_GB) {
        return `${Math.round(mbValue * 100) / 100}MB`;
    }

    // 1GB 이상이면 GB로 반환
    const gbValue = mbValue / MB_IN_GB;
    return `${Math.round(gbValue * 100) / 100}GB`;
}

// 브라우저 확인 함수
export const whichBrowserDoYouUse = (): browserCodeType => {
    let RTN: browserCodeType = BROWSER_CODE.Other;

    const userAgent = navigator.userAgent.toLowerCase();

    if(userAgent.includes("kakaotalk")){
        RTN = BROWSER_CODE.KakaoTalk; // 카카오톡 인앱 브라우저
    }else if(userAgent.includes("fbav") || userAgent.includes("fban")){
        RTN = BROWSER_CODE.Facebook; // 페이스북 인앱 브라우저
    }else if(userAgent.includes("instagram")){
        RTN = BROWSER_CODE.Instagram; // 인스타그램 인앱 브라우저
    }else if(userAgent.includes("line")){
        RTN = BROWSER_CODE.LINE; // 라인 인앱 브라우저
    }else if(userAgent.includes("crios")){
        RTN = BROWSER_CODE.Chrome; // iOS 크롬 브라우저
    }else if(userAgent.includes("chrome")){
        RTN = BROWSER_CODE.Chrome; // 일반 크롬 브라우저
    }else if(userAgent.includes("safari")){
        RTN = BROWSER_CODE.Safari; // 사파리 브라우저
    }

    return RTN;
};

// 운영체제를 확인해주는 함수
export const getMobileOperatingSystem = (): "iOS" | "Android" | "Other" => {
    const userAgent = navigator.userAgent.toLowerCase();

    // iOS 감지
    if (/ipad|iphone|ipod/.test(userAgent) && !(window as any).MSStream) {
        return "iOS";
    }

    // 안드로이드 감지
    if (/android/.test(userAgent)) {
        return "Android";
    }

    // 그 외 환경 (데스크탑 등)
    return "Other";
};

// 외부 브라우저로 리다이렉트를 시켜주는 주소 생성
class getRedirectUrlClass{
    KakaoTalk(){
        const currentURL = window.location.href
        return "kakaotalk://web/openExternal?url="+encodeURIComponent(currentURL);
    }

    LINE(){
        const currentURL = window.location.href
        if(currentURL.indexOf("?") !== -1){
            return currentURL+"&openExternalBrowser=1";
        }else{
            return currentURL+"?openExternalBrowser=1";
        }
    }
}
export const getRedirectUrl = new getRedirectUrlClass();

// 인앱 브라우저를 닫는데 사용되는 url
class getCloseInAppBrowserUrlClass{
    KakaoTalk(){
        const os = getMobileOperatingSystem();
        if(os === "Android"){
            return "kakaotalk://inappbrowser/close";
        }else if(os === "iOS"){
            return "kakaoweb://closeBrowser";
        }else{
            return "";
        }
    }
}
export const getCloseInAppBrowserUrl = new getCloseInAppBrowserUrlClass();

// 외부 브라우저를 열어주는 함수
class openInExternalBrowserClass extends getRedirectUrlClass{
    KakaoTalk_open(){
        setTimeout(() => {
            window.location.href = getCloseInAppBrowserUrl.KakaoTalk();
        }, 500)

        window.location.href = this.KakaoTalk();
    }

    LINE_open(){
        setTimeout(() => {
            window.close();
        }, 500)

        window.location.href = this.LINE();
    }

    auto_open(){
        const l_browserCode = whichBrowserDoYouUse();

        if(l_browserCode === BROWSER_CODE.KakaoTalk){
            this.KakaoTalk_open();
        }else if(l_browserCode === BROWSER_CODE.LINE){
            this.LINE_open();
        }
    }
}
export const openInExternalBrowser = new openInExternalBrowserClass();

// PhotoSwipeGallery에서 사용되는 뷰포트 사이즈를 리턴해주는 함수
export const getViewportSize = () => {
    const viewport_width = window.innerWidth - 50;
    const viewport_height = window.visualViewport ? window.visualViewport.height - 50 : window.innerHeight - 50;

    return ({
        viewport_width,
        viewport_height
    })
}

// 개발용 - 토큰을 통해 직접 로그인을 진행할 경우 활용
class adminTokenLoginClass{
    isTokenLoginMode(){
        return (process.env.REACT_APP_USE_TOKEN_LOGIN === "TRUE");
    }

    token(){
        return process.env.REACT_APP_TOKEN || "";
    }
}

export const adminTokenLogin = new adminTokenLoginClass();

// Date객체를 다루는 클래스
export class dateObjectManagerClass{

    getWeekday(date: string | Date){
        let RTN: string = "";

        const date_time = new Date(date);

        if(!isNaN(date_time.getTime())){
            const weekday_ko_list: string[] = ["일", "월", "화", "수", "목", "금", "토"];
            const weekday = weekday_ko_list[date_time.getDay()];
            RTN = weekday;
        }

        return RTN;
    }

    // 날짜를 설정한 형식의 문자열로 출력해주는 메소드
    customFormatDate(date: string | Date, formatString: string = "yyyy년 MM월 dd일"){
        try {
            const date_time = new Date(date);

            if(isNaN(date_time.getTime())){
                dev_console.error("Invalid date");
                return "";
            }else{
                return format(date_time, formatString);
            }
        } catch (error) {
            dev_console.error("Invalid date format");
            dev_console.error(error);
            return "";
        }
    };

    // Date객체의 날짜 비교를 위해 년, 월, 일의 정보만 제외하고 초기화
    removeTime(date: Date){
        const reset_date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        if(isNaN(reset_date.getTime())){
            return null
        }else{
            return reset_date;
        }
    }

    // 두 날짜 사이의 간격을 구하는 메소드
    getDaysDifference(date1: string | Date, date2: string | Date): number | null {
        const d1 = new Date(date1);
        const d2 = new Date(date2);

        if (isNaN(d1.getTime()) || isNaN(d2.getTime())) return null;

        // 날짜 비교니까 시간 제거
        d1.setHours(0, 0, 0, 0);
        d2.setHours(0, 0, 0, 0);

        const msPerDay = 1000 * 60 * 60 * 24;
        const diffMs = d1.getTime() - d2.getTime();

        return Math.floor(diffMs / msPerDay); // 음수/0/양수 반환
    }

    // date1이 date2보다 과거(-1), 현재(0), 미래(1)인지 시간까지 비교하여 판단
    // 기준점은 date2다.
    compareDateTime(date1: string | Date, date2: string | Date): -1 | 0 | 1 | null {
        const d1 = new Date(date1);
        const d2 = new Date(date2);

        if (isNaN(d1.getTime()) || isNaN(d2.getTime())) return null;

        const diff = d1.getTime() - d2.getTime();

        if (diff > 0) return 1;
        if (diff < 0) return -1;
        return 0;
    }

    // 인자로 들어온 날짜가 오늘로부터 며칠 떨어진 날짜인지 계산한다.
    // 양수 : 오늘보다 미래
    // 음수 : 오늘보다 과거
    getDaysDifferenceFromToday(targetDate: string | Date, includeTime: boolean = false){
        let RTN: number | null = null;

        if(!targetDate){
            return null;
        }

        const target_datetime = new Date(targetDate);
        if(isNaN(target_datetime.getTime())){
            return null;
        }

        if(!includeTime){
            target_datetime.setHours(0, 0, 0, 0);
        }

        const today = new Date(); // 현재 날짜와 시간을 포함하는 Date 객체를 생성합니다.

        if(!includeTime){
            today.setHours(0, 0, 0, 0);
        }

        if(!includeTime){
            RTN = this.getDaysDifference( today, target_datetime);
        }else{
            RTN = this.compareDateTime(today, target_datetime);
        }

        return RTN;
    }

    // 두 날짜의 분 차이를 리턴
    getMinuteDifference(date1: string, date2: string){
        let date1_datetime = new Date(date1);
        let date2_datetime = new Date(date2);

        if(isNaN(date1_datetime.getTime()) || isNaN(date2_datetime.getTime())){
            dev_console.error("date객체로 변환이 불가능한 인자값");
            return 0;
        }

        // 두 날짜의 시간 차이를 밀리초로 계산하고 절대값 처리
        let diffInMilliseconds = Math.abs(date1_datetime.getTime() - date2_datetime.getTime());

        // 값이 음수면 양수로 변환한다.
        if(diffInMilliseconds < 0){
            diffInMilliseconds = diffInMilliseconds * -1;
        }

        // 밀리초를 분으로 변환
        const RTN = Math.floor(diffInMilliseconds / (1000 * 60));

        return RTN;
    }

    // 일을 입력받아서 해당일을 기간 단위로 변환해주는 메소드
    // 과거, 미래표현 기준.
    // days가 음수다 -> 오늘 - 지정된날짜가 음수값이다 -> 지정된 날짜가 오늘보다 이후에 있다 -> 미래다.
    // days가 양수다 -> 오늘 - 지정된날짜가 양수다 -> 지정된 날짜가 오늘보다 이전에 있다 -> 과거다.
    calculatePeriod(days: number){
        const POINT_OF_VIEW_CODE = {
            past: -1,
            present: 0,
            future: 1,
        } as const;

        type pointOfViewCodeType = typeof POINT_OF_VIEW_CODE [keyof typeof POINT_OF_VIEW_CODE];

        let m_point_of_view: pointOfViewCodeType = POINT_OF_VIEW_CODE.present;

        if(days < 0){
            m_point_of_view = POINT_OF_VIEW_CODE.future;
        }else if(days > 0){
            m_point_of_view = POINT_OF_VIEW_CODE.past;
        }else{
            m_point_of_view = POINT_OF_VIEW_CODE.present
        }

        // 일수 차이값을 절대값처리해준다.
        let m_days = days;
        if(m_days < 0){
            m_days = m_days * -1;
        }

        let RTN: string = "";

        SetDayText: {
            // 오늘
            if(m_point_of_view === POINT_OF_VIEW_CODE.present){
                RTN = "오늘";
                break SetDayText;
            }

            // 1일 전 후
            if(m_days === 1){
                if(m_point_of_view === POINT_OF_VIEW_CODE.past){
                    RTN = "어제";
                }else{
                    RTN = "내일";
                }
                break SetDayText;
            }

            // // 2일 전 후
            // if(m_days === 2){
            //     if(m_point_of_view === POINT_OF_VIEW_CODE.past){
            //         RTN = "그저께";
            //     }else{
            //         RTN = "모레";
            //     }
            //     break SetDayText;
            // }

            // 7일 전 후
            if(m_days < 7){
                if(m_point_of_view === POINT_OF_VIEW_CODE.past){
                    RTN = `${m_days}일 전`;
                }else{
                    RTN = `${m_days}일 후`;
                }
                break SetDayText;
            }

            // 한달 전 후
            if(m_days < 30){
                if(m_point_of_view === POINT_OF_VIEW_CODE.past){
                    RTN = `${Math.floor(m_days / 7)}주 전`;
                }else{
                    RTN = `${Math.floor(m_days / 7)}주 후`;
                }
                break SetDayText;
            }

            // 1년 전 후
            if(m_days < 365){
                if(m_point_of_view === POINT_OF_VIEW_CODE.past){
                    RTN = `${Math.floor(m_days / 30)}개월 전`; // 단순화를 위해 모든 달을 30일로 계산
                }else{
                    RTN = `${Math.floor(m_days / 30)}개월 후`; // 단순화를 위해 모든 달을 30일로 계산
                }
                break SetDayText;
            }

            // 1년을 초과함
            if(m_point_of_view === POINT_OF_VIEW_CODE.past){
                RTN = `${Math.floor(m_days / 365)}년 전`; // 단순화를 위해 모든 달을 30일로 계산
            }else{
                RTN = `${Math.floor(m_days / 365)}년 후`;// 단순화를 위해 모든 달을 30일로 계산
            }
        }

        return RTN;
    }

    // 인자로 들어온 날짜가 오늘로부터 떨어진 시간을 계산하여 문자로 표현으로 리턴해준다.(1초전, 하루전, 한달전...)
    dateCalculatePeriod(date: Date) {
        const now = new Date();
        let m_diff_seconds = Math.floor((date.getTime() - now.getTime()) / 1000);

        type timeDirection_Type = "past" | "future";

        const timeDirection: timeDirection_Type = m_diff_seconds < 0 ? "past" : "future";

        if(m_diff_seconds < 0){
            m_diff_seconds = m_diff_seconds * -1;
        }

        let RTN: string = "";

        SetDayText: {
            if(m_diff_seconds < 60){
                RTN = `${m_diff_seconds}초`;
                break SetDayText;
            }

            if(m_diff_seconds < 60 * 60){
                RTN = `${Math.floor(m_diff_seconds / 60)}분`;
                break SetDayText;
            }

            if(m_diff_seconds < 60 * 60 * 24){
                RTN = `${Math.floor(m_diff_seconds / (60 * 60))}시간`;
                break SetDayText;
            }
        }

        ExceptionHandling:{
            // SetDayText에서 세팅이 이루어지지 못했다면, 하루를 넘어가는 경우이므로 계산단위를 일로 변경한다
            if(!RTN){
                const m_dday = Math.floor(m_diff_seconds / (60 * 60 * 24));
                RTN = this.calculatePeriod(m_dday);
                break ExceptionHandling;
            }

            if(timeDirection === "past"){
                RTN = `${RTN} 전`;
            }else{
                RTN = `${RTN} 후`;
            }
        }

        return RTN;
    }

    // 24시간 포기법을 가진 문자열(HH:mm)을 12시간 표기법으로 변환
    getClockTimeAMPMString(
        {
            time,
        }:{
            time: string
        }
    ){
        let RTN: {
            AmPmTime: string,
            ampm: {
                state: boolean, // 오전이면 false, 오후면 true
                ko: string,
                en: string,
            }
        } = {
            AmPmTime: "",
            ampm: {
                state: false,
                ko: "",
                en: "",
            }
        }

        if(time.length !== 5){
            dev_console.error("시간을 표시하는 문자열의 길이가 맞지 않습니다.", time.length);
            return null;
        }

        const m_split_time = time.split(":");
        if(m_split_time.length !== 2){
            dev_console.error("시간 표시 문자열이 올바른 형식이 아닙니다.", m_split_time.length);
            return null;
        }

        const m_hour = customParseInt(m_split_time[0]);
        const m_minute = customParseInt(m_split_time[1]);

        if(m_hour === null || m_minute === null){
            dev_console.error("시간을 숫자로 변환하는데 실패했습니다.", m_hour, m_minute);
            return null;
        }

        if(m_hour > 23 || m_minute > 59){
            dev_console.error("정상적인 시간 범의내의 숫자가 아닙니다.", m_hour, m_minute);
            return null;
        }

        if(m_hour >= 12){
            RTN.AmPmTime = `${m_hour - 12}:${m_minute}`
            RTN.ampm.state = true;
            RTN.ampm.ko = "오후";
            RTN.ampm.en = "PM";
        }else{
            RTN.AmPmTime = `${m_hour}:${m_minute}`
            RTN.ampm.state = false;
            RTN.ampm.ko = "오전";
            RTN.ampm.en = "AM";
        }

        return RTN;
    }

    // 해당 달의 첫쨋날 1주 전과 마지막날의 1주 후를 구한다.
    getMonthBeforeAfterWeekDate(selectedDate: Date){
        const year = selectedDate.getFullYear();
        const month = selectedDate.getMonth(); // 월은 0부터 시작합니다.

        // 해당 월의 첫 날과 마지막 날 구하기
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0); // 다음 달의 0일은 현재 달의 마지막 날입니다.

        // 첫 날에서 7일 전과 마지막 날에서 7일 후 계산
        const weekBefore = new Date(firstDay);
        weekBefore.setDate(firstDay.getDate() - 7);

        const weekAfter = new Date(lastDay);
        weekAfter.setDate(lastDay.getDate() + 7);

        return { weekBefore, weekAfter };
    }

    // 서버에서 전달해주는 yyyyMMdd, yyyyMMddHHmm, yyyyMMddHHmmss 형식의 문자열을 사용자가 원하는 형식의 문자열로 변환해주는 메소드
    changeServerDateToFormatDateString(serverDate: string, formatString: string = "yyyy년 MM월 dd일 HH시 mm분"){
        interface data_Interface{
            format: string;
            date: Date | null;
        }

        const RTN: RTN_interface<data_Interface> = {
            sign: false,
            data: {
                format: "",
                date: null,
            },
            msg: "",
        }

        const m_serverDate_length = serverDate.length;

        CheckDate:{
            if(m_serverDate_length !== 8 && m_serverDate_length !== 12 && m_serverDate_length !== 14){
                RTN.sign = false;
                RTN.msg = "사용가능한 문자열 형식은 yyyyMMdd, yyyyMMddHHmm, yyyyMMddHHmmss 입니다.";
                break CheckDate;
            }

            RTN.sign = true;
        }

        SetDateString:{
            if(!RTN.sign){
                break SetDateString;
            }

            let m_date_string: string = "";

            switch(m_serverDate_length){
                case 8:
                    m_date_string = serverDate.substring(0, 4) + "-" + serverDate.substring(4, 6) + "-" + serverDate.substring(6, 8);
                    break;
                case 12:
                    m_date_string = serverDate.substring(0, 4) + "-" + serverDate.substring(4, 6) + "-" + serverDate.substring(6, 8) + " " + serverDate.substring(8, 10) + ":" + serverDate.substring(10, 12);
                    break;
                case 14:
                    m_date_string = serverDate.substring(0, 4) + "-" + serverDate.substring(4, 6) + "-" + serverDate.substring(6, 8) + "  " + serverDate.substring(8, 10) + ":" + serverDate.substring(10, 12) + ":" + serverDate.substring(12, 14);
                    break;
            }

            const m_date_object = new Date(m_date_string);

            const m_format_date_string = this.customFormatDate(m_date_string, formatString);

            if(m_format_date_string.length === 0){
                RTN.sign = false;
                RTN.msg = "날짜 형식 변환에 실패했습니다.";
                break SetDateString;
            }

            RTN.sign = true;
            RTN.data.format = m_format_date_string;
            RTN.data.date = m_date_object;
        }

        if(!RTN.sign){
            dev_console.error(RTN.msg);
        }

        return RTN.data;
    }
}

// 랜덤한 값을 생성해주는 클래스
export class getRandomValueClass{
    // 특정 정수범위 내에서 랜덤으로 정수를 뽑아주는 메소드
    getRandomInt(min: number, max: number){
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // 랜덤으로 색을 뽑아주는 함수
    getRandomColor(){
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
}

// g_display_none_object클래스를 적용해주는 함수
export const isHiddenClassNameSetter = (
    {
        classNameList,
        isHidden,
        display,
    }:{
        classNameList: string[],
        isHidden?: isHiddenType
        display?: "flex"
    }
) => {
    let RTN: string[] = [];

    RTN.push("g_display_none_object");

    if(isHidden){
        RTN.push(isHidden);
    }

    if(display){
        RTN.push(display);
    }

    RTN = [...RTN, ...classNameList]

    return RTN;
}

// 쿼리파라미터를 포함한 url를 생성해주는 함수
export const getQueryParamsUrl = (
    {
        main_url,
        queryParams,
    }:{
        main_url: string;
        queryParams: string[][] | Record<string, string> | string | URLSearchParams;
    }
) => {
    const m_queryParams_url = new URLSearchParams(queryParams).toString();
    const RTN = `${main_url}?${m_queryParams_url}`;
    return RTN;
}

// 문자열을 정수로 변환해주는 함수
// 변환 후 정상적인 숫자인지 검증하는 로직이 추가됬다.
export const customParseInt = (str: string | null | undefined) => {
    let RTN: number | null = null;

    if(!str){
        RTN = null;
    }else{
        const m_result = parseInt(str);

        if(isNaN(m_result)){
            RTN = null;
        }else{
            RTN = m_result;
        }
    }

    return RTN;
}

// 텍스트 클립보드에 복사기능
export const textCopy = (
    {
        copy_target_text,
        toast_id,
        copy_message,
    }:{
        copy_target_text: string;
        toast_id?: string;
        copy_message?: string;
    }
) => {
    if(copy_target_text){
        navigator.clipboard.writeText(copy_target_text)
        .then(() => {
            customToast.success({
                msg: copy_message ? copy_message : "클립보드에 복사되었습니다.",
                toastId: toast_id,
                autoClose: 1000 * 1,
            });
        })
        .catch(() => {
            customToast.error({
                msg: "클립보드 복사에 실패했습니다.",
                toastId: toast_id,
                autoClose: 1000 * 1,
            });
        })
    }
}

export const isMaintenancePageOn = () => {
    const m_is_alive = process.env.REACT_APP_SERVER_IS_ALIVE;

    if(m_is_alive === "FALSE"){
        return true;
    }else{
        return false;
    }
}

export class imageDataManagerClass{

    async getImageDpi(file: File){
        const RTN: RTN_interface<dimensions_Interface | null> = {
            sign: false,
            data: null,
            msg: "",
        }

        try {
            // 'XResolution'과 'YResolution' 태그를 지정해서 EXIF 메타데이터를 파싱합니다.
            const exifData = await exifr.parse(file, ['XResolution', 'YResolution']);
            if (exifData && exifData.XResolution && exifData.YResolution) {
                RTN.sign = true;
                RTN.data = {
                    width: exifData.XResolution,
                    height: exifData.YResolution,
                }
                RTN.msg = "success";
            } else {
              RTN.sign = false;
              RTN.data = null
              RTN.msg = "이미지 메타데이터에 DPI 정보가 포함되어 있지 않습니다.";
            }
        }catch(error){
            RTN.sign = false;
            RTN.data = null;
            RTN.msg = `DPI 정보를 읽어오는 중 오류가 발생했습니다`;
            dev_console.error(error);
        }

        if(!RTN.sign){
            dev_console.error(RTN.msg)
        }

        return RTN.data;
    }

    // 이미지파일데이터에서 px값을 추출하는 함수
    getImageDimensions(file: File): Promise<dimensions_Interface> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);

            img.onload = () => {
                const dimensions = {
                    width: img.naturalWidth,
                    height: img.naturalHeight
                };
                URL.revokeObjectURL(img.src);
                resolve(dimensions);
            };

            img.onerror = () => {
                URL.revokeObjectURL(img.src);
                reject(new Error('Failed to load image'));
            };
        });
    }
}

// /**
//  *  입력된 값이 문자열인 경우 앞뒤 공백을 제거하고, 선택적으로 대소문자를 변경 (문자가 아닌 경우 입력받은 값 그대로 반환)
//  *
//  *  @author Bruce.Cheong    2025-07-29
//  *
//  *  @param   {string} iValue - 문자열
//  *  @param   {string} iChangeCase - 대소문자 변경 옵션
//  *                                  "upper" - 대문자로 변경
//  *                                  "lower" - 소문자로 변경
//  *
//  *  @returns {string} - 변경된 문자열 또는 false
//  *                              (iValue가 문자열이 아니거나 iChangeCase가 유효하지 않은 경우)
//  */
function stringTrim(iValue: string, iChangeCase: string = "") {
    let RTN: string = iValue;

    const _V = {
        valueType   :   typeof iValue as string,
        value       :   iValue as string,
    } as { valueType: string, value: string };

    Close_RTN: {
        // 유효성 검사
        if ( _V.valueType != "string" ) {
            break Close_RTN;
        }

        // 문자열의 앞뒤 공백을 제거
        _V.value = _V.value.trim();

        switch ( iChangeCase.toLowerCase() ) {
            case "upper":
                RTN = _V.value.toUpperCase();
                break;
            case "lower":
                RTN = _V.value.toLowerCase();
                break;
        }
    }

    if ( RTN === null )         { RTN = ""; }
    if ( RTN === undefined )    { RTN = ""; }

    return RTN;
}

// /**
//  * 이미지 파일 객체(File Object)를 받아 Base64 문자열로 변환하는 함수
//  * @param {File} file - input 태그 등을 통해 얻은 File 객체
//  * @returns {Promise<string>} - Base64로 인코딩된 문자열 (Data URL 포함)
//  */
const convertFileToBase64 = (file: File) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      // 변환 시작
      reader.readAsDataURL(file);

      // 성공 시 호출
      reader.onload = () => {
        // reader.result에 "data:image/png;base64,..." 형태의 문자열이 담김
        resolve(reader.result);
      };

      // 실패 시 호출
      reader.onerror = (error) => {
        reject(error);
      };
    });
  };

// 업데이트할 데이터의 구조 정의
interface AttributeUpdateItem {
    matchValue: string;        // 찾을 값 (예: 기존 hash 값)
    newValue: string | number; // 바꿀 값 (예: 새로운 pk 값)
}

/**
 * HTML 문자열 내에서 특정 태그와 속성을 기준으로 요소를 찾아 다른 속성 값을 일괄 변경하는 범용 함수
 *
 * @param htmlString  - 원본 HTML 문자열
 * @param tagName     - 찾을 태그 이름 (예: 'img', 'div', 'span')
 * @param matchAttr   - 식별자로 사용할 속성명 (예: 'data-file-hash', 'data-key')
 * @param targetAttr  - 값을 변경할 대상 속성명 (예: 'data-upload-file-detail-pk', 'data-data')
 * @param updates     - { matchValue, newValue } 형태의 데이터 배열
 * @returns 변환된 HTML 문자열
 */
function updateHtmlElementAttributes(
    htmlString: string,
    tagName: string,
    matchAttr: string,
    targetAttr: string,
    updates: AttributeUpdateItem[]
): string {
    // 1. SSR 방어 (서버 사이드 렌더링 환경에서의 에러 방지)
    if (typeof window === 'undefined' || !window.DOMParser) {
        return htmlString;
    }

    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        updates.forEach(({ matchValue, newValue }) => {
            // 2. 동적 선택자 생성 (Dynamic Selector)
            // 예: div[data-key="my-value"] 형태의 CSS 선택자를 문자열 템플릿으로 만듦
            const selector = `${tagName}[${matchAttr}="${matchValue}"]`;

            const targetElement = doc.querySelector(selector);

            if (targetElement) {
                // 3. 동적 속성 업데이트
                // 인자로 받은 targetAttr 이름으로 속성을 설정
                targetElement.setAttribute(targetAttr, newValue.toString());

                // 만약 테그가 img인경우 src값도 업데이트 해준다.
                if(tagName === "img"){
                    targetElement.setAttribute("src", newValue.toString());
                }
            }
        });

        return doc.body.innerHTML;

    } catch (error) {
        console.error('HTML Parsing Error:', error);
        return htmlString;
    }
}

async function getR2DirectDownloadUrl(
    {
        brand_id,
        upload_file_pk,
        file_name,
    }:{
        brand_id: number;
        upload_file_pk: number;
        file_name?: string;
    }
){
    const url = "api/v3/common/file-download"
    const params = new URLSearchParams({
        brand_id: brand_id.toString(),
        upload_file_pk: upload_file_pk.toString(),
    })

    if(file_name){
        params.append("file_name", file_name);
    }

    const final_url = `${url}?${params.toString()}`;

    dev_console.log(final_url);

    // final_url 자체가 원본 다운로드의 presigned url이므로 그대로 반환한다.
    return `${process.env.REACT_APP_API_URL}/${final_url}`;

    // 과거버전 - API로 presigned url을 요청하는 방식
    // const response = await callAxios.api({
    //     url: final_url,
    //     method: "get",
    // })

    // dev_console.log(response);

    // if(response.status !== 200){
    //     throw new Error("Failed to get R2 direct download URL");
    // }

    // if(response.data.status.code !== 200){
    //     throw new Error(`Failed to get R2 direct download URL, Error: ${response.data.status.message}`);
    // }

    // return response.data.result;
}

// /**
//  *  Promise Pool 함수
//  *
//  *  @author Bruce.Cheong    2025-11-14
//  *
//  *  @param   {Array<Function>}  iTaskArr    - 작업 함수 배열. 각 함수는 Promise를 반환해야 함.
//  *  @param   {number}           iRunLimit   - 동시 실행 제한 수
//  *
//  *  @returns {Promise<Array>} - 모든 작업이 완료된 후 결과 배열 반환
//  *
//  *  @description
//  *  ```
//  *      주어진 작업 함수 배열을 받아서, 지정된 동시 실행 제한 수에 따라 작업을 병렬로 처리하는 Promise Pool
//  *      각 작업 함수는 Promise를 반환해야 하며, 모든 작업이 완료된 후 결과 배열을 반환
//  *  ```
//  *
//  *  @example
//  *  ```
//  *      예제 1: 동시 실행 제한이 있는 작업 처리
//  *      // 작업 함수 배열 생성
//  *      const tasks = [];
//  *      for (let i = 0; i < 10; i++) {
//  *          tasks.push( () => new Promise( (resolve) => {
//  *              setTimeout( () => {
//  *                  console.log(`Task ${i} completed`);
//  *                  resolve(i);
//  *              }, 1000 + Math.random() * 2000);
//  *          }) );
//  *      }
//  *      // Promise Pool 실행 (동시 실행 제한: 3)
//  *      const results = await gf_PROMISE_POOL(tasks, 3);
//  *      console.log('All tasks completed:', results);
//  *      --------------------------------------------------------------------------------------------
//  *      예제 2: 파일 업로드 처리
//  *
//  *      // 파일 업로드 태스크 생성
//  *      const uploadTasks = Array.from(_files).map((iFile, iIndex) => {
//  *          return () => _f_uploadSingleFile(iFile, iIndex, _folderId);
//  *      });
//  *
//  *      // Promise Pool 방식으로 업로드 실행
//  *      await gf_PROMISE_POOL(uploadTasks, _V.parallelUnit);
//  *  ```
//  */
async function promisePool(iTaskArr: any[], iRunLimit: number) {

    const _V: {
        runLimit: number;
        resultArr: Promise<any>[];
        runningArr: Promise<any>[];
    } = {
        runLimit: iRunLimit || 5 ,  /* 동시 실행 제한 수 */

        resultArr: [] ,     /* 작업 결과를 저장 */
        runningArr: [] ,    /* 현재 실행 중인 작업을 저장 */
    };


    /* 작업을 순회하면서 실행 */
    for ( const iTask of iTaskArr ) {
        /* 작업 실행 */
        const _promise = Promise.resolve().then(() => iTask());
        /* 실행 결과 저장 */
        _V.resultArr.push( _promise );

        // 제한 수보다 작업수가 많으면 작업 대기하다가 빈 슬롯 생기면 실행
        if ( _V.runLimit <= iTaskArr.length ) {
            // 작업 완료 시 executing 배열에서 자동으로 자신을 제거
            // 이로 인해 새 작업을 위한 빈 슬롯 생성
            const _endRun: Promise<any> = _promise.then(() => _V.runningArr.splice(_V.runningArr.indexOf(_endRun), 1));

            // 실행 중인 작업 배열에 추가
            _V.runningArr.push(_endRun);

            // 작업이 제한 수에 도달하면 가장 먼저 완료되는 작업을 기다림
            if (_V.runningArr.length >= _V.runLimit) {
                await Promise.race(_V.runningArr);
            }
        }
    }

    // 모든 작업이 완료될 때까지 대기
    const RTN = Promise.all(_V.resultArr);

    console.log("RTN 반환 전=====================================");
    console.log(RTN);
    console.log("================================================");

    return RTN;
}

// /**
//  *  이미지 URL의 실제 존재 여부를 확인하는 함수 (이미지 전용, 메모리 최적화)
//  *
//  *  @author Bruce.Cheong    2026-02-01
//  *
//  *  @param {string} url - 확인할 이미지 URL
//  *
//  *  @returns {Promise<boolean>} - 존재하면 true, 아니면 false
//  */
async function imgUrlCheck(url: string) {

    return new Promise((resolve) => {
        const img = new Image();

        // 타임아웃 설정 (5초)
        const timeout = setTimeout(() => {
            img.src = '';  // 메모리 해제
            img.onload = null;
            img.onerror = null;
            resolve(false);
        }, 5000);

        img.onload = () => {
            clearTimeout(timeout);
            img.src = '';  // 메모리 해제 (중요!)
            img.onload = null;
            img.onerror = null;
            resolve(true);
        };

        img.onerror = () => {
            clearTimeout(timeout);
            img.src = '';  // 메모리 해제
            img.onload = null;
            img.onerror = null;
            resolve(false);
        };

        // 이미지 로드 시작 (브라우저가 자동으로 최적화)
        img.src = url;
    });
}

/**
 * 이미지 URL 배열 중 실제 존재하는 이미지 URL을 선택하는 함수
 * @param urls - 이미지 URL 배열
 * @returns - 실제 존재하는 이미지 URL
 */
async function imgUrlSelecter(urls: string[]) {
    let RTN: string = "";

    for(const url of urls){
        try{
            const isExist = await imgUrlCheck(url);

            if(isExist){
                RTN = url;
                break;
            }
        }catch(error: any){
            // pass
        }
    }

    return RTN;
}

/**
 *  날짜형식 formatting
 *
 *  @author Bruce.Cheong    2026-05-07
 *
 *  @param iData - 날짜 데이터
 *
 *  @returns format된 날짜 문자열 (yyyy-MM-dd)
 */
function formatDate(iData : string | Date) : string {

    let RTN: string = "";

    try {
        const dateObj = dayjs(iData);

        if (!dateObj.isValid()) {
            throw new Error("Invalid date");
        }

        RTN = dateObj.format("YYYY-MM-DD");
    } catch (error) {
        dev_console.error("날짜 형식이 올바르지 않습니다.", error);
    }

    return RTN;
}

/**
 *  날짜시간형식 formatting
 *
 *  @author Bruce.Cheong    2026-05-07
 *
 *  @param iDataTime - 날짜시간 데이터
 *
 *  @returns format된 날짜 문자열 (yyyy-MM-dd HH:mm:ss)
 */
function formatDateTime(iDataTime : string | Date) : string {

    let RTN: string = "";

    try {
        const dateObj = dayjs(iDataTime);

        if (!dateObj.isValid()) {
            throw new Error("Invalid date");
        }

        RTN = dateObj.format("YYYY-MM-DD HH:mm:ss");
    } catch (error) {
        dev_console.error("날짜 형식이 올바르지 않습니다.", error);
    }

    return RTN;
}

export {
    getFileHash,
    callAxios,
    downloadFile,
    isSuccess,
    isNumericString,
    getMaxPageNum,
    transformISOString,
    isValidPhoneNumber,
    addHyphens,
    preloadImages,
    downloadOriginalImages,
    addCommasToPrice,
    sanitizeInput,
    printStateMsg,
    isAbleAccesser,
    validateInput,
    checkOverflow,
    refineString,
    calculateLastDivHeight,
    validatePassword,
    getTimeDifferenceInMinutes,
    validateEmail,
    getGenderCode,
    insertBetweenList,
    isBetweenNum,
    getFileType,
    detectDuplicates,
    setQueryParameter,
    getFileName,
    arraysAreEqual,
    imageFilesUpload,
    stringTrim,
    convertFileToBase64,
    updateHtmlElementAttributes,
    getR2DirectDownloadUrl,
    promisePool,
    imgUrlSelecter,

    formatDate ,
    formatDateTime ,
};
